const imageContext = require.context('./../../images/projects/iden/thub/', false, /\.jpg$/);

export const STORAGE_KEY = 'fichas';
// Función auxiliar para obtener la URL del archivo
export const getImageUrl = (imageName, genero=null) => {
    //console.info(imageName + "image_name")

    try {
        // Usamos './' + imageName para que coincida con el contexto
        //return imageContext(`./${imageName}`);
        //return require(`./../../images/projects/iden/thub/${imageName}`);
        return require('./../../images/projects/iden/thub/' + imageName + '');
    } catch (err) {
        //console.error(`Imagen no encontrada: ${imageName}`, err);
        //return null; // Devuelve algo seguro si la imagen no existe './../../images/projects/portrait/pic1.jpg'
        var defaimage = '';
        if(genero == "Masculino"){
            //console.info("imagen default maculino");
            //var defaimage = require('./../../images/projects/iden/thub/male.jpg');
            return require('./../../images/projects/iden/thub/male.jpg');
        }

        if(genero == "Femenino"){
            //console.info("imagen default Femenino");
            //var defaimage = require('./../../images/projects/iden/thub/female.jpg');
            return  require('./../../images/projects/iden/thub/female.jpg');;
        }        

        return null;
    }
};

export function DateDisplay({ dateFromJSON }) {
    const dateObject = new Date(dateFromJSON);

    // Example using toLocaleDateString
    const displayDate = dateObject.toLocaleDateString('iso', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    // Example using date-fns (if installed)
    // const displayDate = format(dateObject, 'MM/dd/yyyy');
    return dateFromJSON;

    /*             return (
                    <div>
                        <p>Event Date: {displayDate}</p>
                    </div>
                ); */
}


export const generateSlug = (id, title) => {
    // 1. Convertir a minúsculas
    // 2. Reemplazar caracteres que no sean letras, números o espacios con una cadena vacía
    // 3. Reemplazar espacios y guiones con guiones (-)
    const slugifiedTitle = title.toLowerCase()
        .replace(/[^a-z0-9\s-]/g, "")
        .trim()
        .replace(/[\s_-]+/g, "-");

    // Concatenar el ID con el slug
    return `${id}-${slugifiedTitle}`;
};


export const devitems = [
    {
        "id":1,
        "Nombre":"W\u00e1lter Vladimir Sandoval Pe\u00f1ate",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"El Refugio",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"03-04-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Trauma de T\u00f3rax (golpiza) \/ Trauma cerrado de t\u00f3rax, tambi\u00e9n ten\u00eda una mano\nfracturada, lesiones en el rostro y rodillas.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":2,
        "Nombre":"Mauricio Alberto Flores Sorto",
        "Edad":37,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ciudad Delgado",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-04-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Falta de suministros de medicamentos por\nhipertension y ansiedad - falta medicamentos.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":3,
        "Nombre":"Jos\u00e9 Jeremias Dele\u00f3n Escamilla",
        "Edad":39,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Taxista",
        "regionresidia":"San Marcos",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"17-04-2022",
        "causapreiml":"S\u00e9psis secundaria en pierna pleural izquierda.",
        "motivodeceso":"S\u00e9psis secundaria a empiema pleural izquierda provocado por trauma cerrado\nde t\u00f3rax. Vapuleado.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":4,
        "Nombre":"Ricardo Antonio Mej\u00eda Diaz",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"17-04-2022",
        "causapreiml":"Abdomen s\u00e9ptico",
        "motivodeceso":"Abdomen s\u00e9ptico.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":5,
        "Nombre":"Elvis Josu\u00e9 Sanchez Rivera",
        "Edad":22,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Mar\u00eda Ostuma",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"18-04-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Ten\u00eda multiples traumas de T\u00f3rax (golpiza). Hospital dijo por hipertension y muerte s\u00fabita.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":6,
        "Nombre":"Melvin Alexander Palacios Rivera",
        "Edad":28,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Vicente",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"18-04-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":7,
        "Nombre":"\u00d3scar Alfredo Gallegos Pocasangre",
        "Edad":46,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Sensuntepeque",
        "departamento":"Caba\u00f1as",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"20-04-2022",
        "causapreiml":"Trauma craneocef\u00e1lico severo tipo contuso.",
        "motivodeceso":"Trauma craneoencef\u00e1lico severo de tipo\ncontuso.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":8,
        "Nombre":"Maynor Alcidez Cresp\u00edn",
        "Edad":23,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"20-04-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Desnutrici\u00f3n. Causa: sin dato.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":9,
        "Nombre":"Edwin Enrique P\u00e9rez",
        "Edad":39,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Zacatecoluca",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"21-04-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Enfermedad Renal Cr\u00f3nica",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":10,
        "Nombre":"Francisco Manuel Ca\u00f1as Serrano",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero retirado - 18",
        "regionresidia":"Quezaltepeque",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"28-04-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Fue asesinado a golpes dentro del penal por los demas internos.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":11,
        "Nombre":"Jose Luis Guevara Ulloa",
        "Edad":36,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Hospital San Juan de Dios San Miguel",
        "fechadeceso":"29-04-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Solo dur\u00f3 tres d\u00edas en bartolinas, no iba enfermo cuando lo detuvieron.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":12,
        "Nombre":"Ernesto Alexander Loyloy",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandilla 18",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"03-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"La PNC dijo que se cay\u00f3 en la bartolina y se golpe\u00f3 la cabeza.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":13,
        "Nombre":"Miguel \u00c1ngel Flores Guzm\u00e1n",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Nuevo Cuscatl\u00e1n",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"04-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Miguel estaba enfermo. Su familia era consciente de que estaba mal, pero\nconsideraba que se manten\u00eda estable con medicamento.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":14,
        "Nombre":"Sonia Del Carmen L\u00f3pez Acevedo",
        "Edad":56,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Hermana de pandillero",
        "regionresidia":"California",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Ilopango",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"05-05-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"En la esquela del Instituto de Medicina\nLegal y en el acta de reconocimiento de fallecidos del Ministerio de Salud indicaron edema pulmonar.",
        "CAUSA":"Muerte violenta",
        "filter":"Femenino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":15,
        "Nombre":"Luis Fernando Ram\u00edrez Mej\u00eda",
        "Edad":23,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"MS13",
        "regionresidia":"Usulut\u00e1n",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Homicidio tentado en Usulut\u00e1n",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"06-05-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema Pulmonar (tuberculosis) .\nTen\u00eda cuadro de neumon\u00eda y tuberculosis.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":16,
        "Nombre":"Jos\u00e9 Misael Oliva Abarca",
        "Edad":27,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"07-05-2022",
        "causapreiml":"Desequilibro electrol\u00edtico (desnutrici\u00f3n)",
        "motivodeceso":"M\u00e9dico manifest\u00f3 que su muerte se debi\u00f3 a desequilibrio electrol\u00edtico (desnutrici\u00f3n).",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":17,
        "Nombre":"Wilson Alexander Cruz Pineda",
        "Edad":27,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Pedro Masahuat",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"08-05-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema Pulmonar (tuberculosis).",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":18,
        "Nombre":"David Ernesto Juarez \u00c1vila",
        "Edad":46,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"07-05-2022",
        "causapreiml":null,
        "motivodeceso":"Falta de suministro de medicamentos por diabetes.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":19,
        "Nombre":"Michael Geovany Menj\u00edvar Sosa (A) \"Caquita\"",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"La Palma",
        "departamento":"Chalatenango",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"10-05-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Familiares indican que fue golpeado, aunque acta de Medicina Legal solo reconoci\u00f3 un edema pulmonar.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":20,
        "Nombre":"Carlos Wilfredo Sauceda Gonz\u00e1lez",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"10-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Vapuleado",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":21,
        "Nombre":"Sergio Alcides Natividad Calzadilla",
        "Edad":28,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"10-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Vapuleado",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":22,
        "Nombre":"Herberth Daniel Ramos Gonz\u00e1lez",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"MS13",
        "regionresidia":"Apopa",
        "departamento":"San Salvador",
        "recluidopordelito":"Homicidio agravado",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Zacatecoluca",
        "lugareconociron":"Hospital Santa Teresa de Zacatecoluca.",
        "fechadeceso":"10-05-2022",
        "causapreiml":"Tuberculosis",
        "motivodeceso":"Padec\u00eda de tuberculosis pero afirman que fue golpeado mientras era llevado a bartolinas.",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":23,
        "Nombre":"Milton Vladimir Gonz\u00e1lez Vanegas",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Desconocida",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"10-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Base policial establece que fue ingresado en hospital por di\u00e1betes.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":24,
        "Nombre":"Jorge Alberto Henr\u00edquez",
        "Edad":58,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"10-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Fue trasladado al hospital por problemas de salud no especificados.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":25,
        "Nombre":"Jos\u00e9 Miguel Cordova Blanco",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Apopa",
        "departamento":"San Salvador",
        "recluidopordelito":"Violaci\u00f3n agravada continuada",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"11-05-2022",
        "causapreiml":"Insuficiencia respiratoria, desequilibrio electrol\u00edtico,\npancreatitis biliar",
        "motivodeceso":"Permaneci\u00f3 un mes ingresado en hospital por pancreatitis aguda.",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":26,
        "Nombre":"William Alexander Galeas Gonz\u00e1lez",
        "Edad":36,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"12-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Vapuleado. Expediente cl\u00ednico #897287 revela que el paciente lleg\u00f3 con diversos dolores.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":27,
        "Nombre":"Victor Manuel L\u00f3pez Trinidad",
        "Edad":62,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Cojutepeque",
        "departamento":"Cuscatl\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"12-05-2022",
        "causapreiml":"Paro card\u00edaco",
        "motivodeceso":"Falleci\u00f3 por paro card\u00edaco.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":28,
        "Nombre":"Elvis Ernesto Castillo Majano",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Usulut\u00e1n",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"14-05-2022",
        "causapreiml":"Traumas de tipo contundente, escoriaciones\ny equimiocis.",
        "motivodeceso":"Hab\u00eda sido trasladado en estado de gravedad desde el Centro Penal de Izalco.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":29,
        "Nombre":"Humberto Alexander C\u00e1rdenas Blanco",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero-SI-MS",
        "regionresidia":"San Buenaventura",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"15-05-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Familiares indican que fue golpeado.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":30,
        "Nombre":"Romeo Mauricio Posada Urrutia",
        "Edad":57,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Guatagiagua",
        "departamento":"Moraz\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"16-05-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Ten\u00eda se\u00f1ales de haber sido vapuleado. Totalidad del brazo\nderecho morado y algunas partes sin piel.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":31,
        "Nombre":"Jos\u00e9 Guillermo Vides",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"16-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":32,
        "Nombre":"Eduardo Luis Fuentes Reyes (A) \"Queso\"",
        "Edad":31,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Moncagua",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Hospital de Nueva Guadalupe",
        "fechadeceso":"16-05-2022",
        "causapreiml":"Infarto card\u00edaco.",
        "motivodeceso":"Infarto card\u00edaco.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":33,
        "Nombre":"Ren\u00e9 L\u00f3pez Mej\u00eda",
        "Edad":28,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"16-05-2022",
        "causapreiml":"Trauma cerrado de t\u00f3rax",
        "motivodeceso":"Trauma cerrado de t\u00f3rax. El cad\u00e1ver presentaba hematomas en la cara, pecho y brazos.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":34,
        "Nombre":"Juan Jose Iba\u00f1ez Garc\u00eda",
        "Edad":21,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Salcoatit\u00e1n",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"25-05-2022",
        "causapreiml":"Edema pulmonar.",
        "motivodeceso":"Edema Pulmonar.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":35,
        "Nombre":"Jes\u00fas Antonio Navarro Mendoza (A) \"Chucho\"",
        "Edad":22,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero-SI-MS",
        "regionresidia":"Santa Tecla",
        "departamento":"La Libertad",
        "recluidopordelito":"Homicidio y agrupaciones il\u00cdcitas",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"27-05-2022",
        "causapreiml":"Edema pulmonar.",
        "motivodeceso":"Muri\u00f3 en el Hospital Nacional Jorge Mazzini.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":36,
        "Nombre":"Jos\u00e9 Virgilio Mendoza Le\u00f3n",
        "Edad":49,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ahuachap\u00e1n",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"28-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Autoridades dijeron que era desconocida y est\u00e1n a la espera de los an\u00e1lisis de\nMedicina Legal.",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":37,
        "Nombre":"Marco Tulio Castillo Reyes",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Taxista",
        "regionresidia":"Ilopango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"28-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Su familia dijo que ten\u00eda m\u00faltiples golpes\nen el cuerpo y que muri\u00f3 por ello.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":38,
        "Nombre":"Yonis Balmore Lovo Amaya",
        "Edad":47,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Puerto El Triunfo",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"29-05-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema Pulmonar. Ten\u00eda enfermedades de la presi\u00f3n y ri\u00f1ones.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":39,
        "Nombre":"Santos De Jes\u00fas D\u00edaz Rodr\u00edguez",
        "Edad":55,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Luis La Herradura",
        "departamento":"La Paz",
        "recluidopordelito":"Caso 1: Acoso Sexual.\nCaso 2: Al quedar libre el 30 de marzo de 2022, lo vuelven a capturar por agrupaciones il\u00edcitas",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"01-06-2022",
        "causapreiml":"Neumon\u00eda",
        "motivodeceso":"Neumon\u00eda. En sus \u00faltimas horas de vida estuvo\nexpulsando sangre por la boca.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":40,
        "Nombre":"Mario Alexander Regalado Lemus",
        "Edad":24,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Chalchuapa",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"01-06-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema Pulmonar.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":41,
        "Nombre":"Rafael Validez Portillo",
        "Edad":74,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Hospital Salda\u00f1a",
        "fechadeceso":"01-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":42,
        "Nombre":"Jos\u00e9 An\u00edbal Ram\u00edrez M\u00e1rquez",
        "Edad":44,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Hospital Salda\u00f1a",
        "fechadeceso":"01-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":43,
        "Nombre":"Jos\u00e9 Guillermo G\u00e1mez",
        "Edad":86,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Hospital Salda\u00f1a",
        "fechadeceso":"01-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":44,
        "Nombre":"David Habraham Cort\u00e9z Trejo",
        "Edad":65,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"03-06-2022",
        "causapreiml":"Neumon\u00eda",
        "motivodeceso":"Neumon\u00eda",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":45,
        "Nombre":"Erick Jonathan L\u00f3pez Hern\u00e1ndez",
        "Edad":32,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"03-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":46,
        "Nombre":"Jorge Enrique Ponce Flores",
        "Edad":47,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"04-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":47,
        "Nombre":"Jos\u00e9 Luis Moreno Ter\u00e1n (A) \"Chino\"",
        "Edad":18,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero-MS",
        "regionresidia":"Atiquizaya",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas y Extorsi\u00f3n",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"04-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Torturado. Familiares dicen que documento de Medicina Legal no indic\u00f3 nada sobre los golpes y otras lesiones que ten\u00eda en el cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":48,
        "Nombre":"Carlos Alberto Salguero Murcia",
        "Edad":43,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Nahuizalco",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"05-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Ten\u00eda di\u00e1betes y no le suministraron medicamentos.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":49,
        "Nombre":"Jairo Fernando Ayala Segura",
        "Edad":22,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Acajutla",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"06-06-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Falta de asistencia m\u00e9dica dentro del\ncentro penal. Previo a ser capturado presentaba enfermedas.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":50,
        "Nombre":"Jos\u00e9 Manuel Ram\u00edrez Orosco",
        "Edad":26,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Men\u00e9ndez",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"06-06-2022",
        "causapreiml":"Sindrome hipopotasemia severa",
        "motivodeceso":"De acuerdo con el informe, muri\u00f3 por padecer exceso de potasio.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":51,
        "Nombre":"Mario Davis Arias Rivera",
        "Edad":44,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pastor evang\u00e9lico IGLESIA PENIEL y Director de colegio",
        "regionresidia":"Santa Tecla",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"06-06-2022",
        "causapreiml":"Efisema pulmonar",
        "motivodeceso":"La causa de la muerte fue debido a un\nenfisema pulmonar, afirmaron sus parientes.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":52,
        "Nombre":"Carlos Jos\u00e9 Mendoza Lobo",
        "Edad":41,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Sonsonate",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"08-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":53,
        "Nombre":"Jos\u00e9 Milton Leiva Quinteros",
        "Edad":36,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Sensuntepeque",
        "departamento":"Caba\u00f1as",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"08-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":54,
        "Nombre":"Oscar Armando Campos",
        "Edad":39,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Candelaria",
        "departamento":"Cuscatl\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"08-06-2022",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Sus familiares dijeron que les informaron que muri\u00f3 por insuficiencia renal; pero ten\u00eda golpes en su cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":55,
        "Nombre":"Rafael Antonio Quintanilla",
        "Edad":56,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Picahero",
        "regionresidia":"La Uni\u00f3n",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"08-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Falta de medicamentos para padecimientos que ten\u00eda.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":56,
        "Nombre":"Ricardo Patriz Salama",
        "Edad":38,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Panchimalco",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"10-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Asesinado dentro del penal y llevado a Medicina Legal de San Miguel.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":57,
        "Nombre":"Jos\u00e9 Marvin Salmer\u00f3n",
        "Edad":53,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Taxista",
        "regionresidia":"La Uni\u00f3n",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"10-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Enfermedad cr\u00f3nica, amputacion de un\ndedo. No le suministraron medicamentos adecuados.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":58,
        "Nombre":"German Orlando Escobar L\u00f3pez (A) \"Flecha\"",
        "Edad":22,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero-MS",
        "regionresidia":"Cojutepeque",
        "departamento":"Cuscatl\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"11-06-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema pulmonar",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":59,
        "Nombre":"Juan Carlos G\u00f3mez V\u00e1squez",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Gotera",
        "departamento":"Moraz\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"12-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":60,
        "Nombre":"Elias N.",
        "Edad":36,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Hospital San Bartolo",
        "fechadeceso":"12-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Fue ingresado agonizando y falleci\u00f3.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":61,
        "Nombre":"Jose No\u00e9 G\u00f3mez Canales",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"12-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":62,
        "Nombre":"\u00c9dgar Ernesto Gonz\u00e1lez",
        "Edad":37,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Usulut\u00e1n",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"13-06-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Familia presume que habr\u00eda fallecido debido a complicaciones de salud por la cirrosis.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":63,
        "Nombre":"Jos\u00e9 Ruben Uma\u00f1a Flores",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"14-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":64,
        "Nombre":"Marvin Eliofredo G\u00e1mez Amaya",
        "Edad":31,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Payaso",
        "regionresidia":"San Mart\u00edn",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-06-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema pulmonar.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":65,
        "Nombre":"Antonio Venedicto Robles",
        "Edad":85,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Berl\u00edn",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":66,
        "Nombre":"\u00c9dgar Alcidez Diaz (A) \"Choyado\"",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero MS13",
        "regionresidia":"Nueva Concepci\u00f3n",
        "departamento":"Chalatenango",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"17-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":67,
        "Nombre":"Samuel Eliseo Prudencio Mendoza",
        "Edad":38,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero MS13",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"19-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Producto de m\u00faltiples fracturas provocadas por golpes con objeto\ncontundente.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":68,
        "Nombre":"Alexander Roman Ram\u00edrez M\u00e9ndez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"20-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":69,
        "Nombre":"Jose Roberto C\u00e1ceres (A) \"Maitro\"",
        "Edad":48,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero MS13",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"19-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":70,
        "Nombre":"Juan Carlos Ram\u00edrez M\u00e9ndez",
        "Edad":38,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Quezaltepeque",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"21-06-2022",
        "causapreiml":"Edema cerebral",
        "motivodeceso":"Ten\u00eda se\u00f1ales de tortura.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":71,
        "Nombre":"Nelson Ruiz",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"22-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":72,
        "Nombre":"Mario Moises Cardona Lopez",
        "Edad":43,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"24-06-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"La autopsia realizada por Medicina Legal determin\u00f3 que la causa de muerte fue un edema cerebral, pero su familia afirma lo contrario.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":73,
        "Nombre":"Carlos Ernesto Flores Cabrera",
        "Edad":32,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Taxista",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"26-06-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Ten\u00eda se\u00f1ales de tortura.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":74,
        "Nombre":"Francisco Javier Tejada",
        "Edad":28,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Aguilares",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"26-06-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema pulmonar",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":75,
        "Nombre":"Alfredo Aar\u00f3n Morales",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Cuscatancingo",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"27-06-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Supuestamente tuvo una ca\u00edda y muri\u00f3.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":76,
        "Nombre":"Pedro Antonio Vanegas",
        "Edad":34,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"30-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":77,
        "Nombre":"Jos\u00e9 Crist\u00f3bal Cartagena",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"30-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":78,
        "Nombre":"Adrian Efrain Sol\u00f3rzano",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"04-07-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":79,
        "Nombre":"Cristobal Ernesto Renderos Melendez",
        "Edad":34,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Luis La Herradura",
        "departamento":"La Paz",
        "recluidopordelito":"Extorsi\u00f3n",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"09-07-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Al momento de recibir el cuerpo, los\nfamiliares comentaron que presentaba marcas de golpes en distintas partes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":80,
        "Nombre":"Julio Cesar Mendoza Ram\u00edrez",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"14-07-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Golpes y lesiones en distintas partes del cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":81,
        "Nombre":"Raquel Avelar Avelar",
        "Edad":60,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Comerciante",
        "regionresidia":"Tejutla",
        "departamento":"Chalatenango",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"15-07-2022",
        "causapreiml":"Hemorragia cerebral",
        "motivodeceso":"Padecia diabetes. Familiares afirmaron que el cuerpo ten\u00eda lesiones en el rostro y\nen el cr\u00e1neo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":82,
        "Nombre":"Fredy Edgardo Vel\u00e1zquez Guevara",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"21-07-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"El dictamen forense detalla que muri\u00f3 por edema pulmonar.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":83,
        "Nombre":"Mauricio Quintanilla Medrano",
        "Edad":53,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pastor evang\u00e9lico",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"04-08-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"El dictamen forense detalla que muri\u00f3 por\nedema pulmonar, pero no tenia padecimientos previos, seg\u00fan su familia. Afirman que llevaba golpes en el cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":84,
        "Nombre":"Rafael L\u00f3pez Castell\u00f3n",
        "Edad":53,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Molinero",
        "regionresidia":"Jucuapa",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"01-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Aparentemente falta de medicamentos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":85,
        "Nombre":"Rafael Edgardo Aguirre Guinea",
        "Edad":24,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Atiquizaya",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"23-08-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":86,
        "Nombre":"Rolando Eduardo Urquilla Cerritos",
        "Edad":47,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"El Congo",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"23-08-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":87,
        "Nombre":"Dionisio Adonay Ram\u00edrez (Jhony)",
        "Edad":24,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Luis La Herradura",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"24-08-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":88,
        "Nombre":"Francisco Huezo L\u00f3pez",
        "Edad":64,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"La Reina",
        "departamento":"Chalatenango",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"24-08-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":89,
        "Nombre":"Kevin Alexander Portillo Ayala",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"31-08-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":90,
        "Nombre":"Ariel Yanez Antunez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"02-09-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":91,
        "Nombre":"Jose Leonidas Bonilla",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Sindicalista de la Alcald\u00eda Municipal de Mejicanos",
        "regionresidia":"Mejicanos",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"03-09-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Falta de suministro de medicamentos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":92,
        "Nombre":"Jorge",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Isidro",
        "departamento":"Caba\u00f1as",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"14-09-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":93,
        "Nombre":"Jimmy Anthony Zelaya Centeno",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Quelepa",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"22-09-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":94,
        "Nombre":"Henry Eleazar Joya Jovel",
        "Edad":43,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"25-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":95,
        "Nombre":"Jos\u00e9 Seraf\u00edn Guerra Fuentes",
        "Edad":36,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"La Laguna",
        "departamento":"Chalatenango",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"26-09-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"No ten\u00eda enfermedades cr\u00f3nicas y a su familia no les permitieron ver el cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":96,
        "Nombre":"Carlos Ernesto Garc\u00eda Mercado",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Bartolom\u00e9 Perulap\u00eda",
        "departamento":"Cuscatl\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"01-10-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Ten\u00eda tuberculosis.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":97,
        "Nombre":"Jose Gilberto N.",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Pedro Perulap\u00e1n",
        "departamento":"Cuscatl\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Gotera",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"11-10-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":98,
        "Nombre":"Mauricio Ernesto Rodr\u00edguez Bonilla",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Marcos",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"22-10-2022",
        "causapreiml":"Trauma cerrado de t\u00f3rax",
        "motivodeceso":"Falleci\u00f3 por trauma cerrado de abdomen y\npor neumon\u00eda. Ten\u00eda se\u00f1ales de haber sido golpeado.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":99,
        "Nombre":"Miguel \u00c1ngel Pimentel Mart\u00ednez",
        "Edad":58,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ahuachap\u00e1n",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Incumplir medidas judiciales",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"30-10-2022",
        "causapreiml":"Infarto",
        "motivodeceso":"Medicina Legal dice que muri\u00f3 por un\ninfarto agudo del miocardio. Familia se\u00f1al\u00f3 negligencia.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":100,
        "Nombre":"Rufino Leiva",
        "Edad":60,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"09-11-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":101,
        "Nombre":"Ram\u00f3n Gonz\u00e1lez",
        "Edad":55,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pastor evangelico",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En su casa",
        "fechadeceso":"21-11-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":102,
        "Nombre":"Rosa Avil\u00e9s",
        "Edad":76,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Jucuapa",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"29-11-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Las hijas de Rosa dijeron que ella era\nasm\u00e1tica cr\u00f3nica y tambi\u00e9n padec\u00eda de alzheimer.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":103,
        "Nombre":"Marvin Antonio Ben\u00edtez Perlera",
        "Edad":24,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"La Palma",
        "departamento":"Chalatenango",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"01-06-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":104,
        "Nombre":"Isa\u00ed Ramos Sorto",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Molinero",
        "regionresidia":"Usulut\u00e1n",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"22-12-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"En los documentos que le entregaron hace\nconstar que Isa\u00ed muri\u00f3 de un edema pulmonar, aunque nunca les avisaron que estaba enfermo. Creen que fue vapuleado.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":105,
        "Nombre":"V\u00edctor Manuel Melara Ascencio",
        "Edad":32,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"22-12-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Los reos son V\u00edctor Manuel Melara\nAscencio, de 32 a\u00f1os, e Isa\u00ed Ramos Sorto, de 50, quienes se encontraban recluidos en el penal de Izalco.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":106,
        "Nombre":"Juan Carlos Palacios",
        "Edad":42,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Ebrio consuetudinario",
        "regionresidia":"San Esteban Catarina",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"02-01-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Asifixia mec\u00e1nica por ahorcamiento.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":107,
        "Nombre":"Ezequiel Humberto Linares",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"03-01-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":108,
        "Nombre":"Kevin Ernesto Peraza Navas",
        "Edad":27,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Chalchuapa",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Usulut\u00e1n",
        "lugareconociron":"Hospital San Pedro Usulut\u00e1n",
        "fechadeceso":"04-01-2023",
        "causapreiml":"Tuberculosis",
        "motivodeceso":"Seg\u00fan la esquela de Medicina, padeci\u00f3 de \"tuberculosis pulmonar\". Familiares indicaron golpes en su cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":109,
        "Nombre":"Jorge Alberto Jurado Campos",
        "Edad":27,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Comerciante",
        "regionresidia":"Jiquilisco",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"09-01-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Tuvo complicaciones por no recibir su tratamiento m\u00e9dico.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":110,
        "Nombre":"Mario Guillermo Ben\u00edtez",
        "Edad":55,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"11-01-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":111,
        "Nombre":"Jos\u00e9 Fernando Martinez Palma",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Tepecoyo",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"16-01-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":112,
        "Nombre":"Tony Alexander Guardado",
        "Edad":44,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"18-01-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Fuentes policiales confirmaron que el reo\nfalleci\u00f3 en el veh\u00edculo cuando era trasladado a un hospital.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":113,
        "Nombre":"Emilio Salinas Andrade",
        "Edad":53,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Apastepeque",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"28-01-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":114,
        "Nombre":"Abel De Jes\u00fas Polia P\u00e9rez",
        "Edad":39,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Alegr\u00eda",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"31-01-2023",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Polic\u00edas y m\u00e9dicos sostuvieron versi\u00f3n de edema pulmonar, aunque familiares vieron golpes en su cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":115,
        "Nombre":"Noelia Elizabeth Garc\u00eda Hern\u00e1ndez",
        "Edad":42,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Comerciante",
        "regionresidia":"Candelaria de la Frontera",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"01-02-2023",
        "causapreiml":"Carsinoma nasal",
        "motivodeceso":"Seg\u00fan el Instituto de Medicina Legal,\nNoelia muri\u00f3 a causa de un tumor en la nariz (carcinoma nasal). Su familia dijo que entr\u00f3 sana.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":116,
        "Nombre":"Edwin Manuel Flores Coreas",
        "Edad":24,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santiago de Mar\u00eda",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"En su casa",
        "fechadeceso":"10-02-2023",
        "causapreiml":"Gastritis",
        "motivodeceso":"Gastritis cancer\u00edgena que se le origin\u00f3\ndurante los nueve meses que estuvo detenido durante el r\u00e9gimen de excepci\u00f3n.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":117,
        "Nombre":"Franklin Morataya",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"11-02-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Falleci\u00f3 por una serie de fracturas en diversas partes de su cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":118,
        "Nombre":"Oscar Ernesto Hern\u00e1ndez Caballero",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Artista (Se vest\u00eda de Santa Claus)",
        "regionresidia":"Sacacoyo",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"14-02-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"\u00d3scar cont\u00f3 a su familia que por mucho que se quejara de dolor no le daban atenci\u00f3n\nm\u00e9dica.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":119,
        "Nombre":"Cesar Garay",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Juan Opico",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"23-02-2023",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Padec\u00eda de insuficiencia renal.",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":120,
        "Nombre":"Luis Antonio Mart\u00ednez Gonz\u00e1lez",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Trabajaba en una tienda",
        "regionresidia":"Jiquilisco",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"25-02-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Seg\u00fan el acta de defunci\u00f3n \u00e9l muri\u00f3 de meningitis, enfermedad grave y contagiosa.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":121,
        "Nombre":"Fredy Cruz Portillo",
        "Edad":43,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Jiquilisco",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"En su casa",
        "fechadeceso":"26-02-2023",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Fue liberado con un diagn\u00f3stico m\u00e9dico cr\u00edtico: anemia profunda, insuficiencia renal cr\u00f3nica, hipertensi\u00f3n.",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":122,
        "Nombre":"Edy Berrios Castell\u00f3n",
        "Edad":55,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pastor evang\u00e9lico",
        "regionresidia":"Puerto El Triunfo",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"27-02-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Muri\u00f3 dentro de la c\u00e1rcel producto de golpes y facturas en diferentes partes de su cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":123,
        "Nombre":"Carlos Jos\u00e9 Santos Mej\u00eda",
        "Edad":18,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Pedro Perulap\u00e1n",
        "departamento":"Cuscatl\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"04-03-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":124,
        "Nombre":"Osm\u00edn Alberto Bonilla Cardoza",
        "Edad":42,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"06-03-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":125,
        "Nombre":"Jonathan Alexander Cerna Cornejo",
        "Edad":26,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero retirado - MS13",
        "regionresidia":"Rosario de Mora",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"06-03-2023",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Seg\u00fan el dictamen entregado a la familia \u00e9l muri\u00f3 a consecuencia de una enfermedad cr\u00f3nica respiratoria, que se agrav\u00f3 con insuficiencia renal.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":126,
        "Nombre":"Francisco Javier Aguirre Pe\u00f1ate",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"09-03-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Fue ingresado de urgencia en el Hospital Rosales por golpes y ah\u00ed falleci\u00f3.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":127,
        "Nombre":"Rodrigo V\u00e1squez Jr.",
        "Edad":44,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Vendedor de comida",
        "regionresidia":"San Luis La Herradura",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"09-03-2023",
        "causapreiml":"Neumon\u00eda",
        "motivodeceso":"Seg\u00fan familiares, tanto en el hospital como en el Instituto de Medicina Legal les informaron sobre dos causas distintas de muerte. Ten\u00eda golpes en el cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":128,
        "Nombre":"Rene Antonio Mej\u00eda Portillo",
        "Edad":23,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"14-03-2023",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Insuficiencia Renal (antes de capturado no padec\u00eda eso).",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":129,
        "Nombre":"Pedro No\u00e9 Guzm\u00e1n Osorio",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"15-03-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Muri\u00f3 la madrugada del mi\u00e9rcoles 15 de\nmarzo 2023, mientras recib\u00eda asistencia m\u00e9dica. Lleg\u00f3 al hospital con m\u00faltiples fracturas.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":130,
        "Nombre":"Mototaxista de Ahuachap\u00e1n",
        "Edad":24,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Mototaxista",
        "regionresidia":"Ahuachap\u00e1n",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"16-03-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":131,
        "Nombre":"Jos\u00e9 Raul Ram\u00edrez",
        "Edad":36,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Puerto La Libertad",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Ilopango",
        "lugareconociron":"Hospital Molina de Soyapango",
        "fechadeceso":"21-03-2023",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Seg\u00fan el acta m\u00e9dica, \u00e9l falleci\u00f3 por edema pulmonar agudo, pero su familia\ndescribe que ten\u00eda golpes en varias zonas del cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":132,
        "Nombre":"Francisco Antonio Men\u00e9ndez Mendoza",
        "Edad":26,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Tacuba",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En su casa",
        "fechadeceso":"23-03-2023",
        "causapreiml":"Infarto card\u00edaco",
        "motivodeceso":"Le pusieron infarto agudo del miocardio.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":133,
        "Nombre":"Josu\u00e9 Vides",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Candelaria de la Frontera",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Hospital Salda\u00f1a",
        "fechadeceso":"22-03-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":134,
        "Nombre":"Orlando Claros",
        "Edad":26,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En su casa",
        "fechadeceso":"22-03-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":135,
        "Nombre":"Joven de San Miguel",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"10-10-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":136,
        "Nombre":"Jos\u00e9 Israel Cresp\u00edn Solorzano\n",
        "Edad":24,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"02-04-2022",
        "causapreiml":"Excoriaciones a nivel de occipucio, herida en parpado derecho.",
        "motivodeceso":"Responsable de trasladar el cad\u00e1ver le inform\u00f3 a la familia que hab\u00eda sido vapuleado al interior del penal.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":137,
        "Nombre":"Leonardo Vladimir Rivera\nCastillo",
        "Edad":26,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"14-07-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":138,
        "Nombre":"Milton Joel El\u00edas V\u00e1squez",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Tonacatepeque",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"29-03-2023",
        "causapreiml":"Falla multisist\u00e9mica-s\u00e9psis",
        "motivodeceso":"Supuesta falla multisist\u00e9mica secundaria a sepsis, es decir, una infecci\u00f3n generalizada en la sangre, seg\u00fan consta en la esquela.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":139,
        "Nombre":"Hugo Rivas",
        "Edad":48,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"29-03-2023",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Cardio y neuropat\u00eda, diabetes. Edema agudo de pulm\u00f3n (Esquela del IML). El\ncad\u00e1ver presentaba fractura en la nariz.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":140,
        "Nombre":"Francisco Dom\u00ednguez Cornejo",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Se desconoce",
        "fechadeceso":"04-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Capturado con mentiras el 24 de mayo de 2022. Era diab\u00e9tico",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":141,
        "Nombre":"Jos\u00e9 Candelario Navarrete Romero",
        "Edad":62,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Rafael Oriente",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"08-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Su cad\u00e1ver fue trasladado a la sede de\nMedicina Legal de esa localidad a la espera de ser reclamado por familiares.",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":142,
        "Nombre":"Carlos Romero Hern\u00e1ndez L\u00f3pez",
        "Edad":36,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Conchagua",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"05-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":143,
        "Nombre":"Erick Hern\u00e1ndez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Se desconoce",
        "fechadeceso":"08-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":144,
        "Nombre":"Juan Jos\u00e9 Merino Leiva",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Picachero",
        "regionresidia":"San Luis Talpa",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"10-04-2023",
        "causapreiml":null,
        "motivodeceso":"Golpes y fractura de craneo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":145,
        "Nombre":"Dennis Alexander",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Chalatenango",
        "departamento":"Chalatenango",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"15-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":146,
        "Nombre":"Nixon Joel Campos",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Texistepeque",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"19-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":147,
        "Nombre":"Luis Torrez M\u00e9ndez",
        "Edad":19,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Sebasti\u00e1n Salitrillo",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"20-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":148,
        "Nombre":"Miguel Ernesto Iraheta Rodr\u00edguez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"22-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":149,
        "Nombre":"Erick Wilfredo Ulloa Soriano",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Repartidor",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"22-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":150,
        "Nombre":"Carlos Antonio Platero",
        "Edad":41,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Colaborador en parada de buses",
        "regionresidia":"San Juan Opico",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"24-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Presentaba golpes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":151,
        "Nombre":"Jos\u00e9 Ad\u00e1n Quintanilla",
        "Edad":59,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Chinameca",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"26-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Presentaba golpes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":152,
        "Nombre":"Aureliano L\u00f3pez Alvarado",
        "Edad":66,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Jutiapa \/ Guatemala",
        "departamento":"Jutiapa \/ Guatemala",
        "recluidopordelito":"Delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"26-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Presentaba golpes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":153,
        "Nombre":"Marcos Adalberto L\u00f3pez",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Se desconoce",
        "fechadeceso":"28-04-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Presentaba golpes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":154,
        "Nombre":"Alfredo Isa\u00edas Andrade Mart\u00ednez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Trabajaba en La Constancia",
        "regionresidia":"Olocuilta",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"28-04-2023",
        "causapreiml":"Intoxicaci\u00f3n",
        "motivodeceso":"El dictamen forense indica que la causa de su muerte fue por intoxicaci\u00f3n. Sin\nembargo, la familia observ\u00f3 que ten\u00eda golpes en el cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":155,
        "Nombre":"Manuel De La Paz Rivas Hern\u00e1ndez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Sebasti\u00e1n",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"10-05-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":156,
        "Nombre":"Carlos Eli\u00e9zer Gonz\u00e1lez Solano",
        "Edad":41,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Carpintero",
        "regionresidia":"San Luis La Herradura",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"15-05-2023",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Tenia el brazo fracturado (murio por golpes).",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":157,
        "Nombre":"Sandra Yaneth Arreivillaga",
        "Edad":42,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Sebati\u00e1n Salitrillo",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"19-05-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Desnutrici\u00f3n severa",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":158,
        "Nombre":"Santiago Calder\u00f3n Vanegas",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ciudad Arce",
        "departamento":"La Libertad",
        "recluidopordelito":"Homicidio",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"19-05-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":159,
        "Nombre":"David Ernesto Castro",
        "Edad":41,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"C.P.C.P.H. San\nMiguel",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"20-05-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":160,
        "Nombre":"Jose Israel P\u00e9rez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"15-05-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":161,
        "Nombre":"Jos\u00e9 Daniel Hern\u00e1ndez Vel\u00e1zquez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Atiquizaya",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"24-05-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":162,
        "Nombre":"Oscar Armando Gil",
        "Edad":46,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Viv\u00eda en Isla La Pirraya",
        "regionresidia":"Jiquilisco",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital San bartolo",
        "fechadeceso":"26-05-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":163,
        "Nombre":"Erick Oswaldo Erazo God\u00ednez",
        "Edad":37,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Se desconoce",
        "fechadeceso":"31-05-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":164,
        "Nombre":"Paulino Enrique Mel\u00e9ndez Menj\u00edvar",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Comerciante de L\u00e1cteos",
        "regionresidia":"Aguilares",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"07-06-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":165,
        "Nombre":"Julio Cesar Santamar\u00eda",
        "Edad":32,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Mec\u00e1nico",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"10-06-2023",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema pulmonar en esquela, pero ten\u00eda golpes y fractura\nen el cr\u00e1neo. Muri\u00f3 el dia que la UMO hizo requisa.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":166,
        "Nombre":"V\u00edctor Alberto Ferm\u00e1n Molina",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Propietario de una tienda",
        "regionresidia":"San Alejo",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"12-06-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":167,
        "Nombre":"Erick Omar Aguirre Garc\u00eda",
        "Edad":31,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"13-06-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Reportada como muerte natural",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":168,
        "Nombre":"Leonardo Mart\u00ednez Linares",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Ya ten\u00eda una condena en prisi\u00f3n",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Homicidio",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"14-06-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Reportada como muerte natural",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":169,
        "Nombre":"Marvin Alexander Garay Linares",
        "Edad":38,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-06-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Reportada como muerte natural",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":170,
        "Nombre":"Carlos N.",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"17-06-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":171,
        "Nombre":"Luis Armando Rodr\u00edguez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santiago de Mar\u00eda",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"21-06-2023",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Enfermedad pulmonar",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":172,
        "Nombre":"Manuel Antonio Acevedo",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Se desconoce",
        "fechadeceso":"27-06-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":173,
        "Nombre":"Marvin Omar Villegas Rodr\u00edguez",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Chinameca",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Ilopango",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"27-06-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Lo golpearon en el traslado, lo que le provoco la muerte, seg\u00fan su familia.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":174,
        "Nombre":"C\u00e9sar Bladimir Cu\u00e9llar Mart\u00ednez",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Acajutla",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"05-07-2023",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"El cad\u00e1ver presentaba varios moretones en varias partes del cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":175,
        "Nombre":"Marvin Mauricio L\u00f3pez Flores",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Antonio Masahuat",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Santa Teresa de Zacatecoluca.",
        "fechadeceso":"04-07-2023",
        "causapreiml":"\u00dalcera",
        "motivodeceso":"Una \u00falcera que empeor\u00f3 por los maltratos recibidos en el penal.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":176,
        "Nombre":"Guillermo Cruz",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Rosario de Mora",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"En su casa",
        "fechadeceso":"06-07-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":177,
        "Nombre":"Carlos Daniel Linares",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Candelaria de la Frontera",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"05-07-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":178,
        "Nombre":"Jos\u00e9 Roger D\u00edaz Pineda",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Jiquilisco",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"09-07-2022",
        "causapreiml":"Neumon\u00eda",
        "motivodeceso":"Seg\u00fan Medicina Legal muri\u00f3 por neumon\u00eda en la cl\u00ednica del reclusorio; tambi\u00e9n estaba desnutrido.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":179,
        "Nombre":"Jos\u00e9 Edgardo Hern\u00e1ndez Men\u00e9ndez",
        "Edad":34,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Hospital Santa Teresa de Zacatecoluca.",
        "fechadeceso":"10-07-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Desnutrici\u00f3n severa mientras recib\u00eda atenci\u00f3n m\u00e9dica en el Hospital Nacional\nSanta Teresa de esa localidad.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":180,
        "Nombre":"Fanny Del Carmen Morales Miranda",
        "Edad":36,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas y tr\u00e1fico de droga",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"10-07-2023",
        "causapreiml":"S\u00e9psis y ca\u00edda de su propia altura",
        "motivodeceso":"Ten\u00eda cinco d\u00edas de estar ingresada por varias \u00falceras.",
        "CAUSA":"Muerte violenta",
        "filter":"Femenino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":181,
        "Nombre":"Sonia Magaly Bonilla S\u00e1nchez",
        "Edad":45,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"10-07-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Ella permanec\u00eda hospitalizada desde el 23 de junio para recibir tratamiento m\u00e9dico para unas \u00falceras que le hab\u00edan salido en el cuerpo.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":182,
        "Nombre":"Dina Elizabeth Galicia De Mendoza",
        "Edad":39,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Enfermera",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"23-07-2023",
        "causapreiml":"Neumon\u00eda y di\u00e1betes",
        "motivodeceso":"Ingres\u00f3 el viernes 21 por problemas de neumon\u00eda y diabetes, y muri\u00f3 dos d\u00edas\ndespu\u00e9s.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":183,
        "Nombre":"Mar\u00eda Dolores De Alvarado",
        "Edad":50,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"23-07-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Femenino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":184,
        "Nombre":"Catalino Portillo Gonz\u00e1lez (A ) \"El Stand\"",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pastor evang\u00e9lico - Pandillero retirado MS13",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Morgue",
        "fechadeceso":"29-07-2023",
        "causapreiml":"Sinusitis",
        "motivodeceso":"Padecia sinusitis. Muri\u00f3 sentado dentro de la bartolina.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":185,
        "Nombre":"Wilfredo Alexander Orellana",
        "Edad":32,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Mototaxista",
        "regionresidia":"San Juli\u00e1n",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"02-08-2023",
        "causapreiml":"Paro card\u00edaco",
        "motivodeceso":"Por falta de atenci\u00f3n m\u00e9dica. Padec\u00eda de convulsiones y del coraz\u00f3n.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":186,
        "Nombre":"Osmin Hern\u00e1ndez",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"La Uni\u00f3n",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"01-08-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"A la familia le informaron hasta que faclleci\u00f3 en el hospital, a pesar que fue ingresado el 20 de julio.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":187,
        "Nombre":"Manuel Merino",
        "Edad":55,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Clara",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"En Morgue IML",
        "fechadeceso":"05-08-2023",
        "causapreiml":"Desnutrici\u00f3n",
        "motivodeceso":"Seg\u00fan informaci\u00f3n de allegados a la familia, estaba calav\u00e9rico por desnutrici\u00f3n, ten\u00eda golpes en el cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":188,
        "Nombre":"No\u00e9 Alexander Rivera Vazquez",
        "Edad":23,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Vendedor de pan en motocicleta",
        "regionresidia":"Jiquilisco",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"05-02-2023",
        "causapreiml":"Neumon\u00eda",
        "motivodeceso":"Dictamen de su fallecimiento se\u00f1ala que muri\u00f3 por problemas respiratorios. Su familia asegur\u00f3 que su apariencia era diferente.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":189,
        "Nombre":"Deysi Araceli Molina Montano",
        "Edad":45,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ciudad Delgado",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"24-08-2023",
        "causapreiml":"C\u00e1ncer",
        "motivodeceso":"Deysi sufr\u00eda de c\u00e1ncer en la matriz e insuficiencia renal.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":190,
        "Nombre":"Jos\u00e9 Dimas Guti\u00e9rrez Ch\u00e1vez",
        "Edad":64,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Jucuapa",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En su casa",
        "fechadeceso":"01-07-2023",
        "causapreiml":"C\u00e1ncer",
        "motivodeceso":"El promotor de salud termin\u00f3 confinado por varios meses en la c\u00e1rcel, donde\nperdi\u00f3 el ojo izquierdo y se enferm\u00f3.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":191,
        "Nombre":"Juan De Jes\u00fas Orellana",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Gotera",
        "departamento":"Moraz\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"25-08-2023",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Seg\u00fan un m\u00e9dico internista del Hospital Nacional de San Francisco Gotera, Juan estaba muy grave y sin atenci\u00f3n adecuada.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":192,
        "Nombre":"Carlos Abarca L\u00f3pez",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Zacatecoluca",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"27-08-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":193,
        "Nombre":"Luis Iv\u00e1n Mej\u00eda Bonilla",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Artista. Trabajaba como payaso y m\u00fasico",
        "regionresidia":"Santiago Nonualco",
        "departamento":"La Paz",
        "recluidopordelito":"Homicidio (orden administrativa)",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Hospital Santa Teresa de Zacatecoluca.",
        "fechadeceso":"03-05-2023",
        "causapreiml":"Covid19",
        "motivodeceso":"Sospechas de que muri\u00f3 por desangramiento en el tubo digestivo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":194,
        "Nombre":"Venancio Antonio Su\u00e1rez Aguirre",
        "Edad":46,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Juay\u00faa",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"28-08-2023",
        "causapreiml":"Trauma cerrado de t\u00f3rax",
        "motivodeceso":"Seg\u00fan medicina legal, tenia da\u00f1ado un pulm\u00f3n, presuntamente por golpes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":195,
        "Nombre":"Medardo Antonio Callejas Renderos",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"31-07-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Tuberculosis",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":196,
        "Nombre":"David Orlando Mej\u00eda El\u00edas",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Tonacatepeque",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"18-09-2023",
        "causapreiml":"Hematoma subdural",
        "motivodeceso":"Muri\u00f3 a consecuencia de un hematoma subdural, es decir, por una\nhemorragia que podr\u00eda ser consecuencia de golpes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":197,
        "Nombre":"Luis Alfredo Araujo",
        "Edad":27,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero MS13",
        "regionresidia":"Santiago de Mar\u00eda",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Primero absuelto por acoso y luego recapturado por Agrupaciones Il\u00edcitas",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"01-10-2023",
        "causapreiml":"Neumon\u00eda bilateral",
        "motivodeceso":"Neumon\u00eda bilateral",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":198,
        "Nombre":"Oscar Armando Lozano Mendoza",
        "Edad":33,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Ex militar",
        "regionresidia":"Puerto El Triunfo",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"07-10-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos. Su familia no accedi\u00f3 a compartir acta de defunci\u00f3n.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":199,
        "Nombre":"Jos\u00e9 Alexander Monjar\u00e1s Serrano",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Usulut\u00e1n",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Posesi\u00f3n y tenencia de drogas",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"09-10-2023",
        "causapreiml":"Insuficiencia respiratoria",
        "motivodeceso":"Muri\u00f3 por supuesta insuficiencia respiratoria.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":200,
        "Nombre":"H\u00e9ctor David Arana",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Motorista de un microb\u00fas",
        "regionresidia":"Atiquizaya",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Se desconoce",
        "fechadeceso":"01-09-2023",
        "causapreiml":"Neumon\u00eda",
        "motivodeceso":"Seg\u00fan centros penales la causa de su muerte fue por neumon\u00eda, pero nunca recibi\u00f3 atenci\u00f3n m\u00e9dica.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":201,
        "Nombre":"Samuel Bernardo Jandres Soriano",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Se dedicaba a vender tortillas con su esposa",
        "regionresidia":"San Rafael Oriente",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"09-10-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":202,
        "Nombre":"Jose Rub\u00e9n Rivas De Paz",
        "Edad":33,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Agust\u00edn",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"08-10-2023",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Presuntamente por una enfermedad pulmonar.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":203,
        "Nombre":"Jos\u00e9 Manuel L\u00f3pez",
        "Edad":72,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Armenia",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"06-05-2023",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Padec\u00eda insuficiencia renal cr\u00f3nica, estaba recluido en penal de Quezaltepeque.",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":204,
        "Nombre":"Juan Carlos Bernardina",
        "Edad":31,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Nahuizalco",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Ciudad Barrios",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"15-09-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":205,
        "Nombre":"Johan Sebastian Calder\u00f3n",
        "Edad":23,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"15-10-2023",
        "causapreiml":"Golpes",
        "motivodeceso":"Seg\u00fan Medicina Legal, la causa de su muerte fue por golpes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":206,
        "Nombre":"Jen Kelin Quintanilla Rivas",
        "Edad":32,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ereuayqu\u00edn",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Condenado delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"16-10-2023",
        "causapreiml":"Ca\u00edda de 100 metros",
        "motivodeceso":"De acuerdo al MOVIR, con informaci\u00f3n proporcionada por la funeraria que dio el tratamiento al cuerpo, su muerte fue por una ca\u00edda ocasionada intencionalmente.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":207,
        "Nombre":"Walter Ulises Alas",
        "Edad":34,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Chalatenango",
        "departamento":"Chalatenango",
        "recluidopordelito":"Condenado delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"21-10-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":208,
        "Nombre":"Jos\u00e9 Dimas Medrano Del Cid",
        "Edad":37,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Rosario La Paz",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"25-10-2023",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Estaba en etapa terminal de insuficiencia renal cr\u00f3nica. Jos\u00e9 estaba\nrecluido en el penal de Quezaltepeque.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":209,
        "Nombre":"Manuel De Jes\u00fas Perdomo Hern\u00e1ndez",
        "Edad":28,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"25-10-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Seg\u00fan la familia, Manuel presentaba perforaciones en sus dedos y manos,\nten\u00eda roto su cr\u00e1neo y la quijada.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":210,
        "Nombre":"H\u00e9ctor Antonio Canales Mercado",
        "Edad":44,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Hermano de \"Lady Drag\"",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"27-10-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"H\u00e9ctor padec\u00eda de asma y problemas card\u00edacos y necesitaba de tratamiento m\u00e9dico y medicinas que no le dieron.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":211,
        "Nombre":"Juan Jos\u00e9 Torrez",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pescador",
        "regionresidia":"Chirilagua",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"27-10-2022",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Torres fue reportado como muerto cuatro d\u00edas despu\u00e9s de\nhaber sido detenido y dos d\u00edas despu\u00e9s de llegar a un penal.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":212,
        "Nombre":"Joel Ernesto Matamoros",
        "Edad":28,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Cuisnahuat",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"03-11-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":213,
        "Nombre":"Javier Hern\u00e1ndez",
        "Edad":17,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Futbolista",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"08-11-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":214,
        "Nombre":"Ver\u00f3nica Del Carmen Manc\u00eda",
        "Edad":32,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"09-11-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Femenino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":215,
        "Nombre":"Fredy Alexander Hern\u00e1ndez",
        "Edad":26,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Limpiaba buses",
        "regionresidia":"Guadalupe",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"14-11-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Falleci\u00f3 a causa de fuertes golpes en el penal de Mariona.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":216,
        "Nombre":"Edwin Ernesto Pleitez",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Trabajaba en f\u00e1brica textil",
        "regionresidia":"Rosario La Paz",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"16-11-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Edwin trabajaba en fabrica textil El Pedregal, Rosario La Paz, y padec\u00eda de falta\nde potasio e hipertensi\u00f3n.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":217,
        "Nombre":"Yolanda Reinosa Ascencio",
        "Edad":50,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"El Refugio",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital de Chalchuapa",
        "fechadeceso":"18-11-2023",
        "causapreiml":"Colangitis bacteriana",
        "motivodeceso":"Colangitis provocada por una infecci\u00f3n bacteriana.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":218,
        "Nombre":"Juan Carlos Bonilla Quintanilla",
        "Edad":39,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Chirilagua",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"17-11-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":219,
        "Nombre":"Ang\u00e9lica Marina Uma\u00f1a",
        "Edad":26,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Intipuc\u00e1",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"30-11-2023",
        "causapreiml":"Asfixia",
        "motivodeceso":"Seg\u00fan informaci\u00f3n oficial, muri\u00f3 \"ahorcada en la celda\". Ten\u00eda 26 a\u00f1os de\nedad.",
        "CAUSA":"Aparente suicidio",
        "filter":"Femenino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":220,
        "Nombre":"Jaime Colindres",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Cinquera",
        "departamento":"Caba\u00f1as",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"En su casa",
        "fechadeceso":"01-12-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sali\u00f3 grave de salud del penal.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":221,
        "Nombre":"Jos\u00e9 Emilio Canizales Villalta",
        "Edad":27,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Jiquilisco",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"01-12-2023",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Insuficiencia renal cr\u00f3nica. Estuvo hospitalizado de gravedad",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":222,
        "Nombre":"Gonzalo Reyes",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Sensuntepeque",
        "departamento":"Caba\u00f1as",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"02-12-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Padec\u00eda de una enfermedad cr\u00f3nica, situaci\u00f3n que le provoc\u00f3 la muerte en pocos meses por las condiciones que viven los presos.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":223,
        "Nombre":"Jos\u00e9 Luis Timo",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Antonio del Monte",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"26-11-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":224,
        "Nombre":"Edwin Isai Argumedo Rodr\u00edguez",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Apopa",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"07-12-2023",
        "causapreiml":"\u00dalcera de c\u00fabito",
        "motivodeceso":"\u00dalcera de c\u00fabito etapa cinco, seg\u00fan diagn\u00f3stico del hospital.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":225,
        "Nombre":"Jorge Alberto V\u00e1squez",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero MS13",
        "regionresidia":"Panchimalco",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"23-12-2023",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema Pulmonar",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":226,
        "Nombre":"Mario Ernesto Hern\u00e1ndez Figueroa",
        "Edad":24,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Candelaria de la Frontera",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"28-12-2023",
        "causapreiml":"Deshidrataci\u00f3n",
        "motivodeceso":"Desequilibrio electrol\u00edtico y anemia severa (deshidrataci\u00f3n).",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":227,
        "Nombre":"Juan Antonio Hern\u00e1ndez",
        "Edad":60,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Rosa de Lima",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"29-12-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":228,
        "Nombre":"Roque Garc\u00eda",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"El Congo",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"30-12-2023",
        "causapreiml":"Di\u00e1betes",
        "motivodeceso":"Diab\u00e9tico",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":229,
        "Nombre":"Miguel Reyes Flores",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ilobasco",
        "departamento":"Caba\u00f1as",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"02-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":230,
        "Nombre":"Reinaldo Osmaro Menj\u00edvar Mendez",
        "Edad":32,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor y ganadero",
        "regionresidia":"Acajutla",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital San Rafael",
        "fechadeceso":"14-01-2023",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Su cuerpo ten\u00eda golpes en la cara y cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":231,
        "Nombre":"Erika Tatiana Vega Flores",
        "Edad":40,
        "SEXO":"Femenino",
        "PANDILLERO":"SI",
        "profesion":"Pandillera Barrio 18",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Extorsi\u00f3n y agrupaciones il\u00edcitas",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"11-01-2024",
        "causapreiml":"Neumon\u00eda bacteriana",
        "motivodeceso":"Neumon\u00eda bacteriana",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":232,
        "Nombre":"Cristian Alexander P\u00e9rez Cortez",
        "Edad":20,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Sonzacate",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"17-01-2024",
        "causapreiml":"Hipotensi\u00f3n",
        "motivodeceso":"Hipotensi\u00f3n",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":233,
        "Nombre":"Jos\u00e9 Ricardo Flores Mej\u00eda",
        "Edad":32,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pescador",
        "regionresidia":"San Luis La Herradura",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"22-01-2024",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema en regi\u00f3n ciliar izquierda, 2.5 cm de di\u00e1metro. Equimosis bolacea en el p\u00e1rpado superior izquierdo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":234,
        "Nombre":"Juan Carlos Garc\u00eda Campos",
        "Edad":49,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"25-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":235,
        "Nombre":"Alex Ernesto Orellana S\u00e1nchez",
        "Edad":48,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"25-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":236,
        "Nombre":"Jos\u00e9 Hern\u00e1n Lievano Trejo",
        "Edad":58,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"27-01-2024",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Insuficiencia renal y di\u00e1betes.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":237,
        "Nombre":"Roberto Alonso Villatoro Guevara",
        "Edad":28,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Trabajaba en negocio familiar de venta de pupusas",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"27-01-2024",
        "causapreiml":"Di\u00e1betes",
        "motivodeceso":"Era hipertenso y diab\u00e9tico. Sospechan que no recibi\u00f3 el tratamiento necesario dentro de la prisi\u00f3n.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":238,
        "Nombre":"Rafael Roca Prieto",
        "Edad":78,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"27-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":239,
        "Nombre":"Luis Alfonso L\u00f3pez",
        "Edad":23,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Motorista de buses",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"28-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":240,
        "Nombre":"Angel Vladimir D\u00edaz Luna",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero MS13",
        "regionresidia":"Guatajiagua",
        "departamento":"Moraz\u00e1n",
        "recluidopordelito":"Homicidio",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"28-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"La causa de su deceso no fue revelada, pero seg\u00fan fuentes m\u00e9dicas ten\u00eda golpes\nen su cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":241,
        "Nombre":"Douglas Gonz\u00e1lez Mor\u00e1n",
        "Edad":48,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Hospital Santa Teresa de Zacatecoluca.",
        "fechadeceso":"01-02-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Seg\u00fan informaci\u00f3n de la Polic\u00eda, la causa de la muerte fue \"complicaciones\nm\u00e9dicas\" de las que no se dio ning\u00fan informe.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":242,
        "Nombre":"Javier Alexander Espa\u00f1a Trinidad",
        "Edad":23,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Ayudante de alba\u00f1il",
        "regionresidia":"Ahuachap\u00e1n",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"04-02-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"El cad\u00e1ver presentaba m\u00faltiples moretones, aparentemente golpes, y un orificio en la cabeza.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":243,
        "Nombre":"Santos Antonio Bola\u00f1os",
        "Edad":34,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Puerto La Libertad",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"07-02-2024",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Su cuerpo presentaba quebradura en sus extremidades.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":244,
        "Nombre":"David Mart\u00ednez Hern\u00e1ndez",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Juan Opico",
        "departamento":"La Libertad",
        "recluidopordelito":"Delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"17-02-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":245,
        "Nombre":"Ra\u00fal Rivera",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pastor evang\u00e9lico",
        "regionresidia":"Tejutla",
        "departamento":"Chalatenango",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"18-02-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":246,
        "Nombre":"Marvin Antonio Amaya Ayala",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Mec\u00e1nico",
        "regionresidia":"Mejicanos",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"26-02-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Estaba \u201cirreconocible\u201d debido a la p\u00e9rdida de peso. Su familia cree que fue producto de algunas enfermedades que pudo adquirir en el penal.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":247,
        "Nombre":"Marta Alicia Granillo De Amaya",
        "Edad":71,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"19-03-2024",
        "causapreiml":"Shop s\u00e9ptico, infecci\u00f3n en vias urinarias, cianosis del h\u00edgado",
        "motivodeceso":"Shop s\u00e9ptico, infecci\u00f3n en vias urinarias, cianosis del h\u00edgado",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":248,
        "Nombre":"Milton Antonio Gonz\u00e1lez",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"21-03-2024",
        "causapreiml":"Congesti\u00f3n nasal viceralizada",
        "motivodeceso":"Congesti\u00f3n visceral generalizada (Esquela\ndel IML). Padec\u00eda de Diabetes. La PNC se neg\u00f3 a recibir sus medicamentos.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":249,
        "Nombre":"Hever Chac\u00f3n",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"L\u00edder sindical de trabajadores de la Terminal de Oriente",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Extorsi\u00f3n y agrupaciones il\u00edcitas",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"26-03-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":250,
        "Nombre":"Jos\u00e9 Balmore D\u00edaz Pineda",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"La Laguna",
        "departamento":"Chalatenango",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"01-04-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":251,
        "Nombre":"Tomas Cortez Rivera",
        "Edad":80,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ciudad Delgado",
        "departamento":"San Salvador",
        "recluidopordelito":"Condenado delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"05-04-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":252,
        "Nombre":"Antonio Cruz",
        "Edad":49,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Sonsonate",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"09-04-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":253,
        "Nombre":"Nicolas Alexander Hern\u00e1ndez",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Taxista",
        "regionresidia":"Usulut\u00e1n",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-04-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":254,
        "Nombre":"Walter William Reyes (A) \"Chucha\"",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pandillero",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"15-04-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":255,
        "Nombre":"Kevin Soriano",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Microbusero",
        "regionresidia":"San Vicente",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas y tr\u00e1fico de droga",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"15-04-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":256,
        "Nombre":"Luis David Amaya Alvarez",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Miembro de Iglesia evang\u00e9lica",
        "regionresidia":"Comacar\u00e1n",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"15-04-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":257,
        "Nombre":"Jos\u00e9 Israel Hern\u00e1ndez Argueta",
        "Edad":33,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Hospital Santa Teresa de Zacatecoluca.",
        "fechadeceso":"16-04-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":258,
        "Nombre":"Ulises Dur\u00e1n",
        "Edad":58,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Hospital Santa Teresa de Zacatecoluca.",
        "fechadeceso":"13-04-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":259,
        "Nombre":"Santos Inocente Mart\u00ednez",
        "Edad":45,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"17-04-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Femenino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":260,
        "Nombre":"Luis Ernesto Rodas Palacios (A) \"Pumba\"",
        "Edad":37,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pandillero",
        "regionresidia":"San Luis La Herradura",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital San Rafael",
        "fechadeceso":"14-05-2024",
        "causapreiml":"Shop s\u00e9ptico",
        "motivodeceso":"IML dijo que muri\u00f3 por shock s\u00e9ptico, pero polic\u00edas informaron a la familia que estaba hospitalizado.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":261,
        "Nombre":"Jos\u00e9 Antonio Hern\u00e1ndez Maye",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"06-05-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":262,
        "Nombre":"Melvin Antonio Rodr\u00edguez",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"27-01-2023",
        "causapreiml":"Epilepsia",
        "motivodeceso":"Era epil\u00e9ptico y no le dieron el medicamento adecuado",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":263,
        "Nombre":"Edwin Geovany Carrillo D\u00edaz",
        "Edad":29,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Panchimalco",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"08-03-2024",
        "causapreiml":"Ingreso al hospital por dolor abdominal agudo y linfoma en cuello.",
        "motivodeceso":"Ingreso al hospital por dolor abdominal agudo y linfoma en cuello. Ten\u00eda un traume en regi\u00f3n abdominal.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":264,
        "Nombre":"Salvador Morales Alfaro",
        "Edad":53,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"07-03-2024",
        "causapreiml":"Di\u00e1betes e infecci\u00f3n las vias urinarias",
        "motivodeceso":"Di\u00e1betes e infecci\u00f3n las vias urinarias",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":265,
        "Nombre":"Luis Efra\u00edn Valle Huezo",
        "Edad":66,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Profesor",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Acoso sexual",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Hospital Santa Teresa de Zacatecoluca.",
        "fechadeceso":"06-03-2024",
        "causapreiml":"Dolor abdominal",
        "motivodeceso":"Dolor abdominal",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":266,
        "Nombre":"Ricardo Fabricio Alvarado Valladares",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"CECOT",
        "lugareconociron":"Hospital Santa Teresa de Zacatecoluca.",
        "fechadeceso":"05-03-2024",
        "causapreiml":"Tuberculosis",
        "motivodeceso":"Tuberculosis",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":267,
        "Nombre":"Carlos G\u00f3mez",
        "Edad":64,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Hospital Santa Teresa de Zacatecoluca.",
        "fechadeceso":"01-03-2024",
        "causapreiml":"Ulsera sacra",
        "motivodeceso":"Ulsera sacra",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":268,
        "Nombre":"Sergio Mardoqueo G\u00f3mez Olmedo",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"29-02-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":269,
        "Nombre":"Emerson Antonio De Paz\nFlores (A) Gato o Saico",
        "Edad":33,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pandillero",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Santa Gertrudis, San Vicente",
        "fechadeceso":"27-02-2024",
        "causapreiml":"Insuficiencia respiratoria",
        "motivodeceso":"Insuficiencia respiratoria",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":270,
        "Nombre":"Juana De Los \u00c1ngeles Argumedo Mauricio",
        "Edad":47,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Comerciante",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"18-02-2024",
        "causapreiml":"Insuficiencia respiratoria",
        "motivodeceso":"Ten\u00eda VIH y di\u00e1betes.",
        "CAUSA":"Enfermedad terminal",
        "filter":"Femenino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":271,
        "Nombre":"Jose Antonio Rodr\u00edguez",
        "Edad":37,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"19-02-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Bajo nivel de potasio",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":272,
        "Nombre":"Francisco S\u00e1nchez Garc\u00eda",
        "Edad":68,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Acajutla",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Salda\u00f1a",
        "fechadeceso":"17-02-2024",
        "causapreiml":"Shok s\u00e9ptico por enfermedad pulmonar",
        "motivodeceso":"Shok s\u00e9ptico por enfermedad pulmonar",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":273,
        "Nombre":"Seraf\u00edn Ernesto Rosales\nAlfaro (A) \"Piporro\" o \"Abuela\"",
        "Edad":29,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Corralero",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"CONDENADO HOM - PROC. AGRUP. IL\u00cdCITAS",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"17-02-2024",
        "causapreiml":"Shock hipovol\u00e9mico (p\u00e9rdida de sangre)",
        "motivodeceso":"Shock hipovol\u00e9mico (p\u00e9rdida de sangre)",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":274,
        "Nombre":"Roberto Carlos Barahona",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"CONDENADO HOM - ROBO",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Ilopango",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"12-02-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":275,
        "Nombre":"Marlon Ad\u00e1n Portillo Ram\u00edrez",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"12-02-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Lleg\u00f3 muerto al hospital",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":276,
        "Nombre":"Esteban P\u00e9rez Calder\u00f3n (A) \"T\u00e9tano\"",
        "Edad":43,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pandillero",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Salda\u00f1a",
        "fechadeceso":"12-02-2024",
        "causapreiml":"Neumon\u00eda",
        "motivodeceso":"Neumon\u00eda",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":277,
        "Nombre":"Luis Miguel Ramos Escobar",
        "Edad":24,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero MS13",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Se encontraba a la orden de un tribunal de sentencia",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"San Vicente",
        "lugareconociron":"Hospital Santa Gertrudis, San Vicente",
        "fechadeceso":"12-02-2024",
        "causapreiml":"Anemia severa",
        "motivodeceso":"Anemia severa",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":278,
        "Nombre":"Salvador Obdulio Hern\u00e1ndez Vides\n(A) \"Spider\"",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pandillero",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Ilopango",
        "lugareconociron":"Hospital San Bartolo",
        "fechadeceso":"09-02-2024",
        "causapreiml":"Tuberculosis",
        "motivodeceso":"Tuberculosis",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":279,
        "Nombre":"Gabrielo Antonio Paiz Guevara",
        "Edad":21,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Salda\u00f1a",
        "fechadeceso":"22-01-2024",
        "causapreiml":"Herida quir\u00fargica afrontada con sutura en forma de C de 35 cms de longitud.",
        "motivodeceso":"Herida quir\u00fargica afrontada con sutura en forma de C de 35 cms de longitud.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":280,
        "Nombre":"Jos\u00e9 Eduardo Salama Maeda",
        "Edad":22,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"19-01-2024",
        "causapreiml":"Gastroenteritis y colitis",
        "motivodeceso":"Gastroenteritis y colitis",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":281,
        "Nombre":"Elias Josu\u00e9 Zapata L\u00f3pez",
        "Edad":27,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Salda\u00f1a",
        "fechadeceso":"17-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":282,
        "Nombre":"Manuel Alexander Retana Pineda",
        "Edad":39,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Otras agresiones sexuales",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"12-01-2024",
        "causapreiml":"Hipertension arterial",
        "motivodeceso":"Hipertension arterial",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":283,
        "Nombre":"Luis Alonso Barrientos Rivas",
        "Edad":27,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"San Vicente",
        "lugareconociron":"Hospital Santa Gertrudis, San Vicente",
        "fechadeceso":"09-01-2024",
        "causapreiml":"Neumon\u00eda aspirativa",
        "motivodeceso":"Neumon\u00eda aspirativa",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":284,
        "Nombre":"Paul Alexander Bermudez Colorado\n(A) \"Luzbel\"",
        "Edad":44,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Pandillero MS13",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Se desconoce",
        "fechadeceso":"06-01-2024",
        "causapreiml":"Deshidrataci\u00f3n",
        "motivodeceso":"Deshidrataci\u00f3n",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":285,
        "Nombre":"Oscar Gustabo Escobar Medina",
        "Edad":43,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"05-01-2024",
        "causapreiml":"Shock hipovul\u00e9mico -\nresultado de sangramiento excesivo",
        "motivodeceso":"Shock hipovul\u00e9mico -\nresultado de sangramiento excesivo",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":286,
        "Nombre":"Walter Geovanny Flores Mungu\u00eda",
        "Edad":32,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"San Vicente",
        "lugareconociron":"Hospital Santa Gertrudis, San Vicente",
        "fechadeceso":"06-01-2024",
        "causapreiml":"Tuberculosis",
        "motivodeceso":"Tuberculosis",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":287,
        "Nombre":"Ever Ricardo Luna Mendoza",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"04-01-2024",
        "causapreiml":"Meningitis bacteriana",
        "motivodeceso":"Meningitis bacteriana",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":288,
        "Nombre":"Gerardo Arturo Cortez P\u00e9rez",
        "Edad":28,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Mesero",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones il\u00edcitas \/ Extorsi\u00f3n",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"30-05-2024",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema pulmonar",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":289,
        "Nombre":"Luis La\u00ednez",
        "Edad":60,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Tecoluca",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"06-06-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":290,
        "Nombre":"Juan Antonio Hern\u00e1ndez Escobar",
        "Edad":56,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Antonio Masahuat",
        "departamento":"La Paz",
        "recluidopordelito":"Agresi\u00f3n sexual en menor e incapaz",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Granja Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"08-06-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":291,
        "Nombre":"Jos\u00e9 Jacinto Majano Rodr\u00edguez",
        "Edad":38,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"08-06-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":292,
        "Nombre":"Donal Atilio Reyes",
        "Edad":60,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"09-06-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":293,
        "Nombre":"Nixon Sigfrido Ayala Mej\u00eda",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Sebastian",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"10-06-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"El fallecimiento fue comunicado a su familia por una funeraria. El cuerpo presentaba m\u00faltiples golpes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":294,
        "Nombre":"\u00c9dgar Mauricio Rivas Martinez",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"12-06-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":295,
        "Nombre":"Jaime Ernesto Coca Ortiz",
        "Edad":38,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Deportado",
        "regionresidia":"San Alejo",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Bartolina Policial",
        "fechadeceso":"07-06-2024",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Padec\u00eda insuficiencia renal antes de su captura y no recibi\u00f3 tratamiento adecuado.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":296,
        "Nombre":"Carlos Antonio Carpio",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"13-06-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":297,
        "Nombre":"Armando Antonio Ram\u00edrez",
        "Edad":27,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Repartidor de Agua Cristal",
        "regionresidia":"Panchimalco",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"14-06-2024",
        "causapreiml":"Paro card\u00edaco",
        "motivodeceso":"Padecia de neumon\u00eda y tuberculosis. Su muerte fue a causa de un paro respiratorio.\u00f1",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":298,
        "Nombre":"Fern\u00e1ndo Antonio Rivas",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"El Paisnal",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"15-06-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":299,
        "Nombre":"Identidad desconocida",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"21-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Familia dice que su cad\u00e1ver ten\u00eda signos de desnutrici\u00f3n severa y golpes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":300,
        "Nombre":"Jonathan Inocente Gonz\u00e1lez Dur\u00e1n",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Agust\u00edn",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"24-11-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":301,
        "Nombre":"Bryan Gabriel Mendoza",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Hospital Santa Gertrudis, San Vicente",
        "fechadeceso":"24-11-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":302,
        "Nombre":"Jos\u00e9 Eduardo L\u00f3pez V\u00e1zquez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Nejapa",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"18-05-2022",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2022,
        "filter3":null,
        "filter4":null
    },
    {
        "id":303,
        "Nombre":"Edwin Cruz",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Rosario La Paz",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"15-11-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":304,
        "Nombre":"Jos\u00e9 Antonio H. M",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Usulut\u00e1n",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"08-05-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":305,
        "Nombre":"Francisco Geovany P. H.",
        "Edad":38,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Zacatecoluca",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"08-05-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":306,
        "Nombre":"V\u00edctor Uriel Granados Hern\u00e1ndez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Apopa",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Hospital Santa Teresa de Zacatecoluca.",
        "fechadeceso":"24-05-2023",
        "causapreiml":"Desnutrici\u00f3n",
        "motivodeceso":"Desnutrici\u00f3n severa",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":307,
        "Nombre":"Identidad desconocida",
        "Edad":65,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"En la calle",
        "fechadeceso":"15-09-2023",
        "causapreiml":"Sin datos",
        "motivodeceso":"Familia dice que sufri\u00f3 golpes en prisi\u00f3n.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":308,
        "Nombre":"Blanca Castro",
        "Edad":60,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Tortillera",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"24-06-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Familia dice que sufri\u00f3 golpes en prisi\u00f3n.",
        "CAUSA":"Muerte violenta",
        "filter":"Femenino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":309,
        "Nombre":"Jos\u00e9 Lorenzo Hern\u00e1ndez",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Gotera",
        "departamento":"Moraz\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"09-07-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":310,
        "Nombre":"Concepci\u00f3n Mel\u00e9ndez",
        "Edad":50,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Rosa de Lima",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"12-06-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Femenino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":311,
        "Nombre":"Marvin Alexis D\u00edaz Lozano",
        "Edad":23,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Trabajaba haciendo viajes con un peque\u00f1o cami\u00f3n",
        "regionresidia":"Santa Elena",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"En su casa",
        "fechadeceso":"28-07-2024",
        "causapreiml":"C\u00e1ncer",
        "motivodeceso":"Cuando lo liberaron padec\u00eda de c\u00e1ncer en un pulm\u00f3n, tuberculosis y una constante\ndiarrea que no cesaba.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":312,
        "Nombre":"Osm\u00edn Orlando Ayala",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Jiquilisco",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"26-07-2024",
        "causapreiml":"Desnutrici\u00f3n",
        "motivodeceso":"Desnutrici\u00f3n severa",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":313,
        "Nombre":"Familia pidi\u00f3 no revelar nombre",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Jiquilisco",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"26-07-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Familia sostiene que fue torturado.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":314,
        "Nombre":"Ram\u00f3n Alcidez Castillo L\u00f3pez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"28-07-2024",
        "causapreiml":"Neumon\u00eda",
        "motivodeceso":"Neumon\u00eda",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":315,
        "Nombre":"Familia pidi\u00f3 no revelar nombre",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Extosi\u00f3n y agrupaciones il\u00edcitas",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"El Espino",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"11-08-2024",
        "causapreiml":"Estrangulamiento",
        "motivodeceso":"Seg\u00fan el examen practicado por Medicina Legal la causa del fallecimiento fue por estrangulamiento.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":316,
        "Nombre":"H\u00e9ctor M. M. M.",
        "Edad":65,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Extosi\u00f3n y agrupaciones il\u00edcitas",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"14-08-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":317,
        "Nombre":"Julio Romero R. T.",
        "Edad":52,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Extosi\u00f3n y agrupaciones il\u00edcitas",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"14-08-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":318,
        "Nombre":"Walter Francisco Cardosa C\u00e1rcamo",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Luis la Herradura",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"21-08-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":319,
        "Nombre":"\u00c1lvaro Eliseo Alas Chac\u00f3n",
        "Edad":20,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Taxista",
        "regionresidia":"Aguilares",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"01-09-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":320,
        "Nombre":"Mario Alexander Hern\u00e1ndez Santos",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Trabajaba en una chatarrera",
        "regionresidia":"San Bartolom\u00e9 Perulap\u00eda",
        "departamento":"Cuscatl\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"01-09-2024",
        "causapreiml":"Neumon\u00eda",
        "motivodeceso":"Falta de tratamiento m\u00e9dico a una enfermedad pulmonar adquirida en el centro penal",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":321,
        "Nombre":"No Nombre",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"06-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Vapuleado cuando lleg\u00f3 a Mariona, tras estar en penal de Izalco",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":322,
        "Nombre":"F\u00e9lix L\u00e1zaro",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Apastepeque",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"01-10-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":323,
        "Nombre":"Mar\u00eda Alicia Segovia de L\u00f3pez",
        "Edad":55,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Moncagua",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"27-09-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Padec\u00eda varias enfermedades.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":324,
        "Nombre":"Jos\u00e9 Martin Sura",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Ex militar",
        "regionresidia":"Santiago de Mar\u00eda",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"05-10-2024",
        "causapreiml":"Desnutrici\u00f3n",
        "motivodeceso":"Fuentes indican que padec\u00eda de desnutrici\u00f3n severa, pero tambi\u00e9n\nestablecieron que el cuerpo presentaba golpes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":325,
        "Nombre":"Mirna Lemus",
        "Edad":50,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Atiquizaya",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"08-10-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":326,
        "Nombre":"Ren\u00e9 Edgardo Ramos",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Sonsonate",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"01-10-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":327,
        "Nombre":"V\u00edctor Manuel Orellana Funes",
        "Edad":60,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"12-10-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":328,
        "Nombre":"Juan Saul Castillo Alberto",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Jorge",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital El Salvador",
        "fechadeceso":"13-10-2024",
        "causapreiml":"Desnutrici\u00f3n",
        "motivodeceso":"Desnutrici\u00f3n severa",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":329,
        "Nombre":"Edwin Emilio Veliz Ulloa",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Puerto La Libertad",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"13-10-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":330,
        "Nombre":"Douglas Omar Medrano V\u00e1squez",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santo Tom\u00e1s",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"17-10-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":331,
        "Nombre":"Estanley Antonio Ju\u00e1rez Ram\u00edrez",
        "Edad":28,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"17-10-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":332,
        "Nombre":"Rudy Armando Garc\u00eda Quijano",
        "Edad":29,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Repartidor",
        "regionresidia":"Rosario de Mora",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"17-01-2024",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema pulmonar",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":333,
        "Nombre":"Luis Alexander Bonilla",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Usulut\u00e1n",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"En su casa",
        "fechadeceso":"16-10-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":334,
        "Nombre":"Santos Antonio Blanco Quintanilla",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Pedro Masahuat",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"20-10-2024",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Familiares y allegados denunciaron que su cad\u00e1ver fue entregado con graves lesiones\ny en evidente estado de desnutrici\u00f3n.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":335,
        "Nombre":"Daniel Ch\u00e1vez Argueta",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Alegr\u00eda",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Bartolina Policial",
        "fechadeceso":"20-10-2024",
        "causapreiml":"Neumon\u00eda",
        "motivodeceso":"A pesar de claros signos de violencia fisica y tortura, la esquela del Instituto de Medicina Legal dictamin\u00f3 la causa como neumon\u00eda.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":336,
        "Nombre":"Irvin Francisco M.A.",
        "Edad":26,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Motorista de bus",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"30-10-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":337,
        "Nombre":"Ana Rosa Cartagena Ar\u00e9valo",
        "Edad":45,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"02-11-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"No ten\u00eda enfermedades previo a ser detenido, pero las adquiri\u00f3 adentro del penal.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":338,
        "Nombre":"Jorge Alberto Rivera Duran",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Vendedor de peri\u00f3dico",
        "regionresidia":"Cojutepeque",
        "departamento":"Cuscatl\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"03-11-2024",
        "causapreiml":"Tuberculosis",
        "motivodeceso":"Tuberculosis",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":339,
        "Nombre":"Juan Eduardo Portillo",
        "Edad":41,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"14-11-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":340,
        "Nombre":"Gerson Menj\u00edvar",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Ex futbolista profesional",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"20-11-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":341,
        "Nombre":"Jos\u00e9 Edwin Molina Castro",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Zacatecoluca",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"20-11-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":342,
        "Nombre":"Juan Carlos A.",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Juli\u00e1n",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"20-11-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":343,
        "Nombre":"C.P.",
        "Edad":33,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Jugador de f\u00fatbol",
        "regionresidia":"Ahuachap\u00e1n",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"30-11-2024",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"A los familiares les dijeron que hab\u00eda muerto por \"edema pulmonar\", es decir, acumulaci\u00f3n de l\u00edquidos en los pulmones.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":344,
        "Nombre":"Delmy Cecilia Barrera Hern\u00e1ndez",
        "Edad":55,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Cuscatancingo",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"En su casa",
        "fechadeceso":"09-01-2024",
        "causapreiml":"Di\u00e1betes",
        "motivodeceso":"\"Al r\u00e9gimen no le importo que mi madre ten\u00eda dos meses de haber sido operada de su intestino diab\u00e9tico. No tuvieron piedad\", declar\u00f3 un familiar de la v\u00edctima.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":345,
        "Nombre":"Samuel Bonifacio Cenado Ram\u00edrez",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Se desconoce",
        "fechadeceso":"12-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Fue llevado de emergencia al hospital en estado muy grave de salud",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2023,
        "filter3":null,
        "filter4":null
    },
    {
        "id":346,
        "Nombre":"Luis Alberto Olmedo Valencia",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"18-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":347,
        "Nombre":"Sonia M. R. G",
        "Edad":40,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Antonio del Monte",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"22-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Femenino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":348,
        "Nombre":"Hector David Antonio Flores",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Santa Ana",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"24-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":349,
        "Nombre":"Santos Navarro",
        "Edad":60,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Comerciante del mercado de Santa Tecla",
        "regionresidia":"Santa Tecla",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"27-01-2024",
        "causapreiml":"Di\u00e1betes",
        "motivodeceso":"Di\u00e1betes",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":350,
        "Nombre":"Carlos Ram\u00f3n Parada Gonz\u00e1lez",
        "Edad":20,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Sal\u00eda en redes sociales haciendo se\u00f1as de pandillas",
        "regionresidia":"Ilopango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"27-01-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Leucemia",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":351,
        "Nombre":"Francisco Antonio Mart\u00ednez Enamorado",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"03-01-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":352,
        "Nombre":"Alfredo N\u00e1jera",
        "Edad":21,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ciudad Arce",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Ciudad Barrios",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"03-01-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Lesiones de bala en el cuerpo.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":353,
        "Nombre":"Antonio Acosta Vel\u00e1zquez",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"07-01-2025",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"Estaba en el penal de Quezaltepeque y le hicieron la primer hemodialisis en el\nHospital Zacamil, pero no fue suficiente.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":354,
        "Nombre":"Celso Mart\u00ednez V\u00e1squez",
        "Edad":52,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"08-01-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":355,
        "Nombre":"Yeferson Yohaldi Campos Mendoza",
        "Edad":24,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Jorge",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hopital San Juan de Dios, San Miguel",
        "fechadeceso":"17-02-2025",
        "causapreiml":"Falla multisist\u00e9mica-s\u00e9psis",
        "motivodeceso":"Falla multiorg\u00e1nica o sepsis, debido a las dialisis que recib\u00eda por la\ninsuficiencia renal",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":356,
        "Nombre":"Edwin Ely Medina Machuca",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Mercedez Uma\u00f1a",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Hospital San Rafael",
        "fechadeceso":"18-01-2025",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema pulmonar",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":357,
        "Nombre":"Nerio Ogui",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Armenia",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"11-01-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":358,
        "Nombre":"Ren\u00e9 Umanzor",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Olocuilta",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"11-01-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":359,
        "Nombre":"Miguel \u00c1ngel Fuentes",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"19-01-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":360,
        "Nombre":"Mar\u00eda de los \u00c1ngeles Murcia",
        "Edad":"Desconocida",
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"21-01-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Ten\u00eda una bacteria y no fue tratada a tiempo.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":361,
        "Nombre":"Jos\u00e9 Alfredo M. P.",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"21-01-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":362,
        "Nombre":"Joel De Jes\u00fas R. C.",
        "Edad":47,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"26-01-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":363,
        "Nombre":"Marlon Antonio S. G.",
        "Edad":59,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"26-01-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":364,
        "Nombre":"Edwin Ernesto G. R.",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Mejicanos",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"16-02-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":365,
        "Nombre":"Amilcar Enrique Mej\u00eda Miranda",
        "Edad":38,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Col\u00f3n",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-02-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":366,
        "Nombre":"Danilo Ernesto Andr\u00e9s L\u00f3pez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Olocuilta",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"14-02-2025",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema pulmonar. Familiares dijo que no recibi\u00f3 atenci\u00f3n m\u00e9dica adecuada.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":367,
        "Nombre":"Jos\u00e9 Miguel Duarte Zetino",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Tonacatepeque",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-02-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":368,
        "Nombre":"Edemir Lemus Quintanilla",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"La Uni\u00f3n",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-02-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":369,
        "Nombre":"H\u00e9ctor Hern\u00e1ndez Castillo",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero MS13",
        "regionresidia":"Ahuachap\u00e1n",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Homicidio",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Ilobasco",
        "lugareconociron":"Hospital Salda\u00f1a",
        "fechadeceso":"08-02-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":370,
        "Nombre":"Josu\u00e9 Omar Castro",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Clasificaci\u00f3n delito desconocido",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Bartolina Policial",
        "fechadeceso":"01-02-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":371,
        "Nombre":"Marvin Alexander V\u00e1squez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"19-02-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":372,
        "Nombre":"\u00c9dgar Oswaldo Ortiz Vel\u00e1zquez",
        "Edad":53,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Mejicanos",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Se desconoce",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"18-02-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":373,
        "Nombre":"Tania Guadalupe Fabi\u00e1n Vel\u00e1squez",
        "Edad":23,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Puerto La Libertad",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"01-03-2025",
        "causapreiml":"C\u00e1ncer",
        "motivodeceso":"C\u00e1ncer terminal",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":374,
        "Nombre":"Jos\u00e9 Ricardo Orellana Ram\u00edrez",
        "Edad":29,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Cuyultit\u00e1n",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"13-02-2025",
        "causapreiml":"Shock hipovol\u00e9mico y deshidrataci\u00f3n severa",
        "motivodeceso":"Shock hipovol\u00e9mico y deshidrataci\u00f3n severa. En Medicina Legal pidieron a la familia que no abrieran la caja, pero constataron que ten\u00eda golpes.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":375,
        "Nombre":"Jos\u00e9 Cristian Hern\u00e1ndez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"07-03-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":376,
        "Nombre":"Reynaldo G. C.",
        "Edad":65,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"18-03-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":377,
        "Nombre":"Marcos Irving B. P.",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"24-03-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":378,
        "Nombre":"Valent\u00edn Lara L\u00f3pez",
        "Edad":41,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Men\u00e9ndez",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"C.P.C.P Santa Ana",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"26-03-2025",
        "causapreiml":"Deshidrataci\u00f3n",
        "motivodeceso":"Deshidrataci\u00f3n",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":379,
        "Nombre":"Wilber Alexander A.G.",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"La Uni\u00f3n",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"29-03-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Las autoridades no quisieron informar las causas de muerte.",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":380,
        "Nombre":"\u00c1ngela Idalia Mart\u00ednez P\u00e9rez",
        "Edad":48,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Cuisnahuat",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"24-03-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Causas de supuestas complicaciones de salud que no fueron detalladas.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":381,
        "Nombre":"\u00d3scar Armando Cedillos Reyes",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero Barrio 18",
        "regionresidia":"Usulut\u00e1n",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"05-04-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":382,
        "Nombre":"Alberto Jos\u00e9 \u00c1vila",
        "Edad":52,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Chalchuapa",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"04-04-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":383,
        "Nombre":"Jos\u00e9 Alfredo Vega Gonz\u00e1lez",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Jiquilisco",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"04-04-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":384,
        "Nombre":"Javier Antonio H. C.",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santiago Nonualco",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"06-04-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":385,
        "Nombre":"Germ\u00e1n Antonio Cortez V\u00e1squez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Sonsonate",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"06-04-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":386,
        "Nombre":"Maritza Santamar\u00eda",
        "Edad":40,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"13-04-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Femenino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":387,
        "Nombre":"Zuleima Garc\u00eda Rivas",
        "Edad":25,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Tacuba",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"15-04-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Femenino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":388,
        "Nombre":"\u00c9dgar Mauricio Aguilar",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"16-04-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":389,
        "Nombre":"Karen Abigail Escobar Mejia",
        "Edad":30,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santo Domingo de Guzm\u00e1n",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"17-04-2025",
        "causapreiml":"Meningitis bacteriana",
        "motivodeceso":"Su familia observo golpes en su cuerpo y cortaduras desde el cuello hacia el rostro.",
        "CAUSA":"Muerte violenta",
        "filter":"Femenino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":390,
        "Nombre":"Ram\u00f3n Abraham Vargas Avila",
        "Edad":52,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"La Uni\u00f3n",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Santa Ana",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"15-04-2025",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Problemas respiratorios no atendidos.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":391,
        "Nombre":"Luis Germ\u00e1n E. H.",
        "Edad":61,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Izalco",
        "departamento":"Sonsonate",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Clasificaci\u00f3n delito desconocido",
        "estatus":"Desconocido",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"25-04-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":392,
        "Nombre":"Francisco Joel P\u00e9rez",
        "Edad":67,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Juay\u00faa",
        "departamento":"Sonsonate",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Clasificaci\u00f3n delito desconocido",
        "estatus":"Desconocido",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-04-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":393,
        "Nombre":"Jos\u00e9 Ernesto Barrera",
        "Edad":31,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Sebasti\u00e1n",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Santa Ana",
        "lugareconociron":"En su casa",
        "fechadeceso":"28-04-2025",
        "causapreiml":"C\u00e1ncer",
        "motivodeceso":"C\u00e1ncer terminal",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":394,
        "Nombre":"Elvin Oswaldo Rodr\u00edguez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Estafa",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Bartolina Policial",
        "fechadeceso":"30-04-2025",
        "causapreiml":"Asfixia",
        "motivodeceso":"Aparente suicidio. Se encontro colgado en la bartolina.",
        "CAUSA":"Aparente suicidio",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":395,
        "Nombre":"V\u00edctor Manuel Orellana Funes",
        "Edad":60,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Sebasti\u00e1n",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"14-10-2024",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2024,
        "filter3":null,
        "filter4":null
    },
    {
        "id":396,
        "Nombre":"Pedro A.G.E",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"MS13",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Homicidio",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"01-05-2025",
        "causapreiml":"Asfixia",
        "motivodeceso":"Aparente suicidio se encontro colgado en la bartolina",
        "CAUSA":"Aparente suicidio",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":397,
        "Nombre":"Identidad desconocida",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Tonacatepeque",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"06-05-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"\u00c9l y su hermano murieron tras ser detenidos y ambos ten\u00edan se\u00f1ales de haber sido vapuleados.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":398,
        "Nombre":"Tom\u00e1s Enrique B. T.",
        "Edad":54,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Nahuilingo",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"10-05-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":399,
        "Nombre":"Jos\u00e9 Roberto Jaco Carranza",
        "Edad":65,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Empresario SEISABUS",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Incumplimiento de deberes, denegaci\u00f3n de\nauxilio y extorsi\u00f3n",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"ISSS Santa Ana",
        "fechadeceso":"12-05-2025",
        "causapreiml":"Di\u00e1betes",
        "motivodeceso":"Di\u00e1betes",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":400,
        "Nombre":"Marlon Raul Ben\u00edtez",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Repartidor de productos y futbolista",
        "regionresidia":"Tonacatepeque",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"17-05-2025",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema pulmonar",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":401,
        "Nombre":"Am\u00edlcar Antonio Campos Ramos",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santiago de Mar\u00eda",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Apropiacion Indebida",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Bartolina Policial",
        "fechadeceso":"22-05-2025",
        "causapreiml":"Di\u00e1betes",
        "motivodeceso":"Campos Ramos fue llevado al Penalito el 6 de mayo y ten\u00eda indicaciones de tomar\nmedicamentos cada d\u00eda, pero no les dieron sus medicamentos y eso complic\u00f3 su salud.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":402,
        "Nombre":"Brayan Alexander Rivera Mej\u00eda",
        "Edad":23,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Feminicidio y violaci\u00f3n",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"21-05-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Golpiza dentro del penal",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":403,
        "Nombre":"Nelson Gabriel Cornejo Le\u00f3n",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"San Juan Opico",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"21-05-2025",
        "causapreiml":"Insuficiencia renal y pulmonar",
        "motivodeceso":"Insuficiencia renal y pulmonar",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":404,
        "Nombre":"Rolando Cruz",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Agricultor",
        "regionresidia":"Nahuizalco",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"23-05-2025",
        "causapreiml":"Tuberculosis",
        "motivodeceso":"El cuerpo presentaba golpes y heridas",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":405,
        "Nombre":"Miguel Angel P. L.",
        "Edad":32,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Caluco",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"23-05-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":406,
        "Nombre":"Denis Alcides Rodr\u00edguez",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Estudiante y comerciante",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"24-05-2025",
        "causapreiml":"Deshidrataci\u00f3n",
        "motivodeceso":"Deshidrataci\u00f3n severa y hongos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":407,
        "Nombre":"Josu\u00e9 Elias D.H.",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ciudad Delgado",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"29-05-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":408,
        "Nombre":"Manuel De Jesus L.M.",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Nahuilingo",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"29-05-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":409,
        "Nombre":"Manuel Alberto Alvarado Rivera",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"30-05-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Aparentemente se tir\u00f3 del edificio donde ejerc\u00eda labores de construcci\u00f3n. Lo manejaron como suicidio.",
        "CAUSA":"Aparente suicidio",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":410,
        "Nombre":"Natividad Ram\u00edrez",
        "Edad":"Desconocida",
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"01-06-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Femenino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":411,
        "Nombre":"Jos\u00e9 Inmer Mej\u00eda Cortez",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Col\u00f3n",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Bartolinas PNC",
        "lugareconociron":"Bartolina Policial",
        "fechadeceso":"03-06-2025",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Edema pulmonar",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":412,
        "Nombre":"Carlos Alberto A. P.",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"13-06-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":413,
        "Nombre":"Gilberto Enrique Santos Palacios",
        "Edad":55,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Marcos",
        "departamento":"San Salvador",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Clasificaci\u00f3n delito desconocido",
        "estatus":"Procesado",
        "centropenal":"Granja Santa Ana",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"12-06-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":414,
        "Nombre":"Juan Antonio Rodr\u00edguez Orellana",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Tonacatepeque",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"20-06-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":415,
        "Nombre":"Carlos Alberto E.E.",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Apopa",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"25-06-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":416,
        "Nombre":"Elder Noel Cruz Mel\u00e9ndez",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Profesor de inform\u00e1tica",
        "regionresidia":"Santo Tom\u00e1s",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zalda\u00f1a",
        "fechadeceso":"29-06-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":417,
        "Nombre":"\u00d3scar David Rosales Torres",
        "Edad":40,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"Pandillero MS13",
        "regionresidia":"San Alejo",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"CECOT",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"01-07-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":418,
        "Nombre":"Oscar Antonio Cruz",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Tr\u00e1fico de drogas",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"02-07-2025",
        "causapreiml":"Di\u00e1betes",
        "motivodeceso":"Di\u00e1betes e infecci\u00f3n en las vias urinarias",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":419,
        "Nombre":"Ricardo Enrique E. V",
        "Edad":41,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Apopa",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"03-07-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Ten\u00eda golpes en la cabeza",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":420,
        "Nombre":"Humberto Adonay Escobar M\u00f3nico",
        "Edad":38,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Mejicanos",
        "departamento":"San Salvador",
        "recluidopordelito":"Contrabando de Mercader\u00eda",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"06-07-2025",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Escoriaciones en la nariz con leves signos de hematoma y tambi\u00e9n un trauma cerrado\nen el cuadrante superior derecho de t\u00f3rax.",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":421,
        "Nombre":"Marvin Ovidio Bonilla Aguilar",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Acajutla",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"12-07-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":422,
        "Nombre":"Jos\u00e9 Luis Canales Ram\u00edrez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Rosa de Lima",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"13-07-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":423,
        "Nombre":"Alma Najarro",
        "Edad":"Desconocida",
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Ana",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios, Santa Ana",
        "fechadeceso":"19-07-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Ten\u00eda diversas enfermedades que no fueron atendidas, seg\u00fan su familia.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Femenino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":424,
        "Nombre":"Identidad desconocida",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Clasificaci\u00f3n delito desconocido",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"19-07-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Aparente deshidrataci\u00f3n",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":425,
        "Nombre":"Identidad desconocida",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Clasificaci\u00f3n delito desconocido",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"19-07-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Aparente deshidrataci\u00f3n",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":426,
        "Nombre":"Kelvin Daniel Hern\u00e1ndez Hidalgo",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ilobasco",
        "departamento":"Caba\u00f1as",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"21-07-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":427,
        "Nombre":"Mario Alfredo Alfaro Orellana",
        "Edad":65,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Men\u00e9ndez",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"08-04-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Medicina Legal realizar\u00eda autopsia pero a\u00fan no brind\u00f3 el resultado.",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":428,
        "Nombre":"Adan Mois\u00e9s Fuentes Sibr\u00edan",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Puerto La Libertad",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"08-08-2025",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Presentaba se\u00f1ales de golpes y tortura",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":429,
        "Nombre":"Roberto Edenilson Rodr\u00edguez Guardado",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Luis Talpa",
        "departamento":"La Paz",
        "recluidopordelito":"Homicidio y agrupaciones il\u00edcitas",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Condenado",
        "centropenal":"CECOT",
        "lugareconociron":"Hospital Rosales",
        "fechadeceso":"08-08-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Ten\u00eda una fractura en el cr\u00e1neo",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":430,
        "Nombre":"Cesar Antonio Mart\u00ednez Ram\u00edrez",
        "Edad":53,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Puerto La Libertad",
        "departamento":"La Libertad",
        "recluidopordelito":"Homicidio y agrupaciones il\u00edcitas",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"08-11-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":431,
        "Nombre":"Oseas Adonay Herrera Serrano",
        "Edad":29,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Lorenzo",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Clasificaci\u00f3n delito desconocido",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"08-12-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":432,
        "Nombre":"Julio Alfredo Rodr\u00edguez Ram\u00edrez",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Profesor",
        "regionresidia":"Acajutla",
        "departamento":"Sonsonate",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"15-08-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Ten\u00eda una bacteria al ser detenido y no le dieron tratamiento m\u00e9dico",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":433,
        "Nombre":"Gerson Andr\u00e9s Fuentes Regalado",
        "Edad":43,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Jos\u00e9 Villanueva",
        "departamento":"La Libertad",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Clasificaci\u00f3n delito desconocido",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"29-08-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":434,
        "Nombre":"Brayan Isaac Cornejo Mej\u00eda",
        "Edad":31,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Jujutla",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Clasificaci\u00f3n delito desconocido",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"29-08-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":435,
        "Nombre":"Jos\u00e9 Rudy Mancilla P\u00e9rez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Clasificaci\u00f3n delito desconocido",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"29-08-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":436,
        "Nombre":"Silvia Garc\u00eda",
        "Edad":"Desconocida",
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Clasificaci\u00f3n delito desconocido",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"29-08-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Femenino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":437,
        "Nombre":"Erick Alberto \u00c1brego \u00c1lvarez",
        "Edad":34,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Usulut\u00e1n",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"30-08-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Tuberculosis",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":438,
        "Nombre":"Edenilson Alberto G\u00f3chez Morales",
        "Edad":46,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Zaragoza",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"06-09-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":439,
        "Nombre":"Nazaret Antonio Alas Nuila",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"06-09-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Ten\u00eda discapacidad mental",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":440,
        "Nombre":"Henry Oswaldo Romero",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Gotera",
        "departamento":"Moraz\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"En su vivienda recien liberado",
        "fechadeceso":"06-09-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Insuficiencia renal",
        "CAUSA":"Enfermedad terminal",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":441,
        "Nombre":"Manuel Mira",
        "Edad":55,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Profesor y sindicalista",
        "regionresidia":"Apastepeque",
        "departamento":"San Vicente",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Usulut\u00e1n",
        "lugareconociron":"En su vivienda recien liberado",
        "fechadeceso":"21-09-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Causa desconocida",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":442,
        "Nombre":"Identidad desconocida",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Nahuizalco",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"25-09-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":443,
        "Nombre":"Juan Jos\u00e9 Mart\u00ednez Ar\u00e9valo",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Men\u00e9ndez",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"20-07-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Insuficiencia Renal",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":444,
        "Nombre":"Carlos Mauricio Mart\u00ednez Ar\u00e9valo",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Men\u00e9ndez",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Delito com\u00fan",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"29-09-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Insuficiencia Renal",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":445,
        "Nombre":"Maria Marisol Elia Henr\u00edquez",
        "Edad":"Desconocida",
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"01-10-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Femenino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":446,
        "Nombre":"Erick Antonio L. G.",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Acajutla",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"San Miguel",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"10-10-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":447,
        "Nombre":"Ismenia Maldonado Mendoza",
        "Edad":35,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocida",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Desconocido",
        "estatus":"Procesado",
        "centropenal":"Apanteos",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"14-10-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Femenino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":448,
        "Nombre":"Kevin Balmore Valencia Guill\u00e9n",
        "Edad":25,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocida",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"24-10-2025",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Descarga el\u00e9ctrica",
        "CAUSA":"Accidente laboral",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":449,
        "Nombre":"Jos\u00e9 Roberto Ju\u00e1rez Romero",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Sesori",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"27-10-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":450,
        "Nombre":"Jos\u00e9 Ra\u00fal V\u00e1squez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"Procesado",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"30-10-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":451,
        "Nombre":"Manuel de Jes\u00fas Hern\u00e1ndez Aguilar",
        "Edad":46,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Jucuapa",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"03-11-2025",
        "causapreiml":"Tuberculosis",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":452,
        "Nombre":"Jorge Alberto Alvarado Mart\u00ednez",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Cojutepeque",
        "departamento":"Cuscatl\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"03-11-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":453,
        "Nombre":"Emerson Anibal Hern\u00e1ndez Molina",
        "Edad":21,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Zalda\u00f1a",
        "fechadeceso":"03-11-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":454,
        "Nombre":"H\u00e9ctor Antonio V\u00e1squez Rodr\u00edguez",
        "Edad":48,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ahuachap\u00e1n",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas \/ Extorsion",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"PROCESADO",
        "centropenal":"Ciudad Barrios",
        "lugareconociron":"Hospital San Juan de Dios, San Miguel",
        "fechadeceso":"06-10-2025",
        "causapreiml":"Insuficiencia renal",
        "motivodeceso":"El cuerpo no ten\u00eda signos evidentes de esa\ncondici\u00f3n, pero s\u00ed extremo deterioro.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":455,
        "Nombre":"Jos\u00e9 Arnulfo Fern\u00e1ndez Flores",
        "Edad":59,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Ciudad Arce",
        "departamento":"La Libertad",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Desconocido",
        "estatus":"Desconocido",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"18-11-2025",
        "causapreiml":"Edema pulmonar",
        "motivodeceso":"Diabetes por una llaga que se le hizo en el pie.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":456,
        "Nombre":"Oscar Armando L\u00f3pez S\u00e1nchez",
        "Edad":54,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Desconocido",
        "estatus":"Desconocido",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"18-11-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":457,
        "Nombre":"Jos\u00e9 Liberto Rivera Huezo",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Salvador",
        "departamento":"San Salvador",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Desconocido",
        "estatus":"Desconocido",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"21-11-2025",
        "causapreiml":"Infarto Agudo de Miocardio",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":458,
        "Nombre":"H\u00e9ctor Omar Trigueros Robles",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Desconocido",
        "estatus":"Desconocido",
        "centropenal":"Izalco",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"22-11-2025",
        "causapreiml":null,
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":459,
        "Nombre":"Ronald Douglas L\u00f3pez Zelaya",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Tecap\u00e1n",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Desconocido",
        "clasifdelito":"Desconocido",
        "estatus":"Desconocido",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"24-11-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":460,
        "Nombre":"Ernesto Antonio Mel\u00e9ndez Fuentes",
        "Edad":34,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Cuscatancingo",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Mariona",
        "lugareconociron":"Zacamil",
        "fechadeceso":"28-11-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Estuvo hospitalizado varios dias",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":461,
        "Nombre":"Candelario Mart\u00ednez",
        "Edad":62,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Jiquilisco",
        "departamento":"Usulut\u00e1n",
        "recluidopordelito":"Homicidio Tentado",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Desconocido",
        "lugareconociron":"Hospital San Juan de Dios, San Miguel",
        "fechadeceso":"09-10-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Estaba lesionado, se autolesion\u00f3 despues del hecho.",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":462,
        "Nombre":"Abel Antonio Navarrete La\u00ednez",
        "Edad":34,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Comerciante",
        "regionresidia":"Sensuntepeque",
        "departamento":"Caba\u00f1as",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Granja Zacatecoluca",
        "lugareconociron":"Hospital Santa Gertrudis, San Vicente",
        "fechadeceso":"03-12-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"por complicaciones en su salud",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":463,
        "Nombre":"Rodrigo Adiel Melgar P\u00e9rez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Acajutla",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"06-12-2025",
        "causapreiml":"EDEMA PULMONAR",
        "motivodeceso":"Sin datos",
        "CAUSA":"Muerte violenta",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":464,
        "Nombre":"Jesus Emilio Guti\u00e9rrez Vega",
        "Edad":43,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Zaragoza",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"13-12-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":465,
        "Nombre":"Jos\u00e9 Fredy D\u00edaz Manzano",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Hacia viajes al aeropuerto",
        "regionresidia":"La Uni\u00f3n",
        "departamento":"La Uni\u00f3n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-12-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":466,
        "Nombre":"Edwin Edgardo Flores Serrano",
        "Edad":49,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Soyapango",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"22-12-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":467,
        "Nombre":"Antonio Valent\u00edn Mateos Palacios",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Ex soldado",
        "regionresidia":"San Pedro Masahuat",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"19-12-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Desnutrici\u00f3n severa e insuficiencia renal",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":468,
        "Nombre":"Jos\u00e9 Rigoberto Beliz Trigueros",
        "Edad":57,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Juan Talpa",
        "departamento":"La Paz",
        "recluidopordelito":"Homicidio Agravado",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"31-12-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":469,
        "Nombre":"Jos\u00e9 Douglas Cabrera Leiva",
        "Edad":32,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Santa Marta",
        "departamento":"Caba\u00f1as",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Mariona",
        "lugareconociron":"Desconocido",
        "fechadeceso":"15-12-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Est\u00e1 en fosa com\u00fan, no ha sido recuperado",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":470,
        "Nombre":"Identidad no autorizada por la familia",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-12-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Familia no quizo dar datos por temor",
        "filter":"Masculino",
        "filter2":2025,
        "filter3":null,
        "filter4":null
    },
    {
        "id":471,
        "Nombre":"Trinidad de Jes\u00fas Lovo Hern\u00e1ndez",
        "Edad":46,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Quelepa",
        "departamento":"San Miguel",
        "recluidopordelito":"Estafa",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios Santa Ana",
        "fechadeceso":"01-01-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Femenino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":472,
        "Nombre":"Jorge A. F. G.",
        "Edad":59,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Miguel",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"01-01-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":473,
        "Nombre":"W\u00e1lter Alex\u00e1nder Hern\u00e1ndez Mart\u00ednez",
        "Edad":35,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Juan Opico",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"CECOT",
        "lugareconociron":"Centro Penal",
        "fechadeceso":"05-01-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":474,
        "Nombre":"Jos\u00e9 Luis Medrano Valladares",
        "Edad":59,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Armenia",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"07-01-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":475,
        "Nombre":"Identidad desconocida",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"13-01-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Falleci\u00f3 mientras era dializado",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":476,
        "Nombre":"Identidad no autorizada por la familia",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"15-01-2025",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":477,
        "Nombre":"Carlos Alberto Nieto (a) Wisnay",
        "Edad":45,
        "SEXO":"Masculino",
        "PANDILLERO":"SI",
        "profesion":"MS13",
        "regionresidia":"Acajutla",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas y TPIAF",
        "clasifdelito":"Agrupaciones Ilicitas y otro delito",
        "estatus":"PROCESADO",
        "centropenal":"Mariona",
        "lugareconociron":"Hospital Zacamil",
        "fechadeceso":"24-01-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":478,
        "Nombre":"Luis Alfredo Campos G\u00f3mez",
        "Edad":39,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"26-01-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":479,
        "Nombre":"Francisco Ernesto Alarc\u00f3n V\u00e1squez",
        "Edad":47,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Sonsonate",
        "departamento":"Sonsonate",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"03-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":480,
        "Nombre":"Jos\u00e9 Ren\u00e9 Villanueva Jardan",
        "Edad":33,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Metap\u00e1n",
        "departamento":"Santa Ana",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"03-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":481,
        "Nombre":"Mario Antonio Iraheta",
        "Edad":50,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Luis Talpa",
        "departamento":"La Paz",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"04-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Hipertensi\u00f3n, anemia y deshidrataci\u00f3n severa",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":482,
        "Nombre":"Manuel de Jes\u00fas Bola\u00f1os",
        "Edad":65,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Sensutepeque",
        "departamento":"Caba\u00f1as",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"06-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":483,
        "Nombre":"Bryan Alexis Cardona Salgado",
        "Edad":31,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Quezaltepeque",
        "departamento":"La Libertad",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"06-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":484,
        "Nombre":"Jos\u00e9 David P\u00e9rez Hern\u00e1ndez",
        "Edad":30,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Moncagua",
        "departamento":"San Miguel",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Quezaltepeque",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"07-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":485,
        "Nombre":"Isidro Hern\u00e1ndez G\u00f3mez",
        "Edad":53,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Nueva Concepci\u00f3n",
        "departamento":"Chalatenango",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"08-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Negligencia por falta de atenci\u00f3n m\u00e9dica",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":486,
        "Nombre":"Blanca Estela Sibri\u00e1n",
        "Edad":50,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Mat\u00edas",
        "departamento":"La Libertad",
        "recluidopordelito":"Extorsi\u00f3n",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"CONDENADO",
        "centropenal":"Apanteos",
        "lugareconociron":"Desconocido",
        "fechadeceso":"10-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Femenino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":487,
        "Nombre":"Gladis Nohemy Arana Maga\u00f1a",
        "Edad":23,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Men\u00e9ndez",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"14-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Femenino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":488,
        "Nombre":"Nilson Alcidez Alfaro Carpio",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Men\u00e9ndez",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"21-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":489,
        "Nombre":"Juan Carlos Arag\u00f3n",
        "Edad":53,
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"San Francisco Men\u00e9ndez",
        "departamento":"Ahuachap\u00e1n",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"21-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":490,
        "Nombre":"Zuleima Fabiola Molina de Medina",
        "Edad":45,
        "SEXO":"Femenino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Desconocida",
        "departamento":"Desconocido",
        "recluidopordelito":"Extorsi\u00f3n",
        "clasifdelito":"Otros delitos no R.E.",
        "estatus":"CONDENADO",
        "centropenal":"Apanteos",
        "lugareconociron":"Hospital San Juan de Dios Santa Ana",
        "fechadeceso":"28-02-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"C\u00e1ncer",
        "CAUSA":"Enfermedad Terminal",
        "filter":"Femenino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    },
    {
        "id":491,
        "Nombre":"Heriberto Ram\u00edrez P\u00e9rez",
        "Edad":"Desconocida",
        "SEXO":"Masculino",
        "PANDILLERO":"NO",
        "profesion":"Desconocida",
        "regionresidia":"Guazapa",
        "departamento":"San Salvador",
        "recluidopordelito":"Agrupaciones Il\u00edcitas",
        "clasifdelito":"Solo Agrupaciones Il\u00edcitas R.E.",
        "estatus":"PROCESADO",
        "centropenal":"Izalco",
        "lugareconociron":"Hospital Jorge Mazzini",
        "fechadeceso":"01-03-2026",
        "causapreiml":"Sin datos",
        "motivodeceso":"Sin datos",
        "CAUSA":"Sin datos",
        "filter":"Masculino",
        "filter2":2026,
        "filter3":null,
        "filter4":null
    }
]

